import { addNA } from "../../function";

export type DrawerProps = {
  file?: any;
  isOpen: boolean;
  onClose: () => void;
  data?: any;
  commentModel: {
    selectedStatus: string;
    open: boolean;
    comment: string;
    roundOff?: any;
  };
  setCommentModel: React.Dispatch<
    React.SetStateAction<{
      selectedStatus: string;
      open: boolean;
      comment: string;
      isMulti?: boolean;
      roundOff?: any;
    }>
  >;
  openSchemaModal: any;
  selectedRows: any[];
  setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>;
  handleGet: () => void;
  name?: any;
  statusType?: any
};

export const companies = [
  {
    company_code: "1000",
    businessArea: "0100",
    name: "Plant 1 - Solid Oral",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0200",
    name: "Plant 2 - Liquid",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0235",
    name: "Akums Plant-2 EU Project(A02)",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0300",
    name: "Plant 3 - Injection",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0400",
    name: "Plant 4 - Hormones",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0500",
    name: "Plant 5 - Cosmetic",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0600",
    name: "Plant 6 - Central Warehouse",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0700",
    name: "Plant 7 - F&D, R&D",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0710",
    name: "Akums-Warehouse",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0800",
    name: "Plant 8 - R&D",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0810",
    name: "AKUMS R&D 2",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0820",
    name: "AKUMS R&D 3 (MUMBAI)",
    GSTIN: "05AAFCD5862R012",
    PAN: "AAFCD5862R",
  },
  {
    company_code: "1000",
    businessArea: "0830",
    name: "AKUMS - R&D Plant-4",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0835",
    name: "Akums R&D Mumbai-EU Project",
    GSTIN: "27AAECA7090B1ZW",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "0900",
    name: "Plant 9 - Akums",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "1100",
    name: "AKUMS - Pure & Cure Site",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "1200",
    name: "AKUMS - Malik Site",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "1210",
    name: "AKUMS - Malik Pencillin",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "1220",
    name: "AKUMS -  Malik-Gen.(LL)",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "1230",
    name: "AKUMS-Malik-Unit-4(LL)",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "5000",
    name: "Akums - Corporate Office",
    GSTIN: "07AAECA7090B2ZX",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "5100",
    name: "AKUMS-KUNDLI",
    GSTIN: "06AAECA7090B1Z0",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "5200",
    name: "AKUMS – NOIDA",
    GSTIN: "09AAECA7090B1ZU",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1000",
    businessArea: "5300",
    name: "Akums Delhi (ISD)",
    GSTIN: "07AAECA7090B4ZV",
    PAN: "AAECA7090B",
  },
  {
    company_code: "1600",
    businessArea: "1600",
    name: "Akums Healthcare- Kotdwar",
    GSTIN: "05AAUCA5830H1ZI",
    PAN: "AAUCA5830H",
  },
  {
    company_code: "1600",
    businessArea: "1610",
    name: "Akums Healthcare Limited-Harid",
    GSTIN: "05AAUCA5830H1ZI",
    PAN: "AAUCA5830H",
  },
  {
    company_code: "1600",
    businessArea: "1620",
    name: "AKUMS HEALTH CARE LTD (AHL-3)",
    GSTIN: "05AAUCA5830H1ZI",
    PAN: "AAUCA5830H",
  },
  {
    company_code: "1600",
    businessArea: "1670",
    name: "AHL Corp.Office-Haridwar",
    GSTIN: "05AAUCA5830H1ZI",
    PAN: "AAUCA5830H",
  },
  {
    company_code: "4000",
    businessArea: "4050",
    name: "Qualymed-Delhi HO",
    GSTIN: "",
    PAN: "AAACQ8981B",
  },
  {
    company_code: "4000",
    businessArea: "4100",
    name: "Qualymed-Haridwar",
    GSTIN: "05AAACQ8981B1ZG",
    PAN: "AAACQ8981B",
  },
  {
    company_code: "4000",
    businessArea: "4200",
    name: "Qualymed- UNIT-1 (Jammu)",
    GSTIN: "01AAACQ8981B1ZO",
    PAN: "AAACQ8981B",
  },
  {
    company_code: "4000",
    businessArea: "4300",
    name: "QUALYMED-UNIT–II (A-16)",
    GSTIN: "01AAACQ8981B2ZN",
    PAN: "AAACQ8981B",
  },
  {
    company_code: "9000",
    businessArea: "9000",
    name: "Maxcure Nutravedics Limited P1",
    GSTIN: "05AAACM2050R1ZF",
    PAN: "AAACM2050R",
  },
  {
    company_code: "9000",
    businessArea: "9010",
    name: "Maxcure - (R&D Plant)",
    GSTIN: "05AAACM2050R1ZF",
    PAN: "AAACM2050R",
  },
  {
    company_code: "9000",
    businessArea: "9050",
    name: "Maxcure - Corporate Office",
    GSTIN: "07AAACM2050R2ZA",
    PAN: "AAACM2050R",
  },
  {
    company_code: "9000",
    businessArea: "9060",
    name: "Maxcure Delhi (ISD)",
    GSTIN: "07AAACM2050R4Z8",
    PAN: "AAACM2050R",
  },
  {
    company_code: "9000",
    businessArea: "9070",
    name: "Maxcure Corp.Office-Haridwar",
    GSTIN: "05AAACM2050R1ZF",
    PAN: "AAACM2050R",
  },
  {
    company_code: "9000",
    businessArea: "9200",
    name: "Maxcure –Trading Division",
    GSTIN: "05AAACM2050R2ZE",
    PAN: "AAACM2050R",
  },
  {
    company_code: "9000",
    businessArea: "9300",
    name: "Maxcure- Derabassi",
    GSTIN: "03AAACM2050R1ZJ",
    PAN: "AAACM2050R",
  },
  {
    company_code: "9400",
    businessArea: "9400",
    name: "Malik - Cephalosporin",
    GSTIN: "05AAECM9025E1ZP",
    PAN: "AAECM9025E",
  },
  {
    company_code: "9400",
    businessArea: "9410",
    name: "Malik - Penicillin",
    GSTIN: "05AAECM9025E1ZP",
    PAN: "AAECM9025E",
  },
  {
    company_code: "9400",
    businessArea: "9420",
    name: "Malik - General",
    GSTIN: "05AAECM9025E1ZP",
    PAN: "AAECM9025E",
  },
  {
    company_code: "9400",
    businessArea: "9430",
    name: "MALIK - UNIT-4",
    GSTIN: "05AAECM9025E1ZP",
    PAN: "AAECM9025E",
  },
  {
    company_code: "9400",
    businessArea: "9440",
    name: "Malik - (R&D Plant)",
    GSTIN: "05AAECM9025E1ZP",
    PAN: "AAECM9025E",
  },
  {
    company_code: "9400",
    businessArea: "9450",
    name: "Malik - Coporate Office",
    GSTIN: "07AAECM9025E1ZL",
    PAN: "AAECM9025E",
  },
  {
    company_code: "9400",
    businessArea: "9460",
    name: "Malik Delhi (ISD)",
    GSTIN: "07AAECM9025E3ZJ",
    PAN: "AAECM9025E",
  },
  {
    company_code: "9400",
    businessArea: "9470",
    name: "Malik Corp.Office-Haridwar",
    GSTIN: "05AAECM9025E1ZP",
    PAN: "AAECM9025E",
  },
  {
    company_code: "9700",
    businessArea: "9700",
    name: "Pure & Cure Healthcare Pvt.Ltd",
    GSTIN: "05AAECP0713G1ZX",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9703",
    name: "Pure & Cure Healthcare Pvt.Ltd",
    GSTIN: "05AAECP0713G1ZX",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9705",
    name: "P&C - Cepha-LL",
    GSTIN: "05AAECP0713G1ZX",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9706",
    name: "P&C - Pencillin-LL",
    GSTIN: "05AAECP0713G1ZX",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9707",
    name: "P&C - Steroid-LL",
    GSTIN: "05AAECP0713G1ZX",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9708",
    name: "P&C - Plant-3 (LL)",
    GSTIN: "05AAECP0713G1ZX",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9709",
    name: "P&C - Plant-1 (LL)",
    GSTIN: "05AAECP0713G1ZX",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9710",
    name: "Pure & Cure - Assam",
    GSTIN: "18AAECP0713G1ZQ",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9711",
    name: "P&C - Plant-2 (LL)",
    GSTIN: "05AAECP0713G1ZX",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9712",
    name: "Pure & Cure - Z",
    GSTIN: "18AAECP0713G1ZQ",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9720",
    name: "P&C - R&D Division",
    GSTIN: "05AAECP0713G1ZX",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9721",
    name: "P&C - R&D Nutravedics",
    GSTIN: "05AAECP0713G1ZX",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9730",
    name: "P&C - Baddi",
    GSTIN: "02AAECP0713G1Z3",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9740",
    name: "Pure and Cure - Baddi 2",
    GSTIN: "02AAECP0713G1Z3",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9750",
    name: "Pure & Cure - Coporate Office",
    GSTIN: "07AAECP0713G2ZS",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9760",
    name: "Pure and Cure_Delhi(ISD)",
    GSTIN: "",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9770",
    name: "P&C Corp.Office - Haridwar",
    GSTIN: "05AAECP0713G1ZX",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9780",
    name: "Akums Life -  Common",
    GSTIN: "06AAECP0713G1ZV",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9781",
    name: "Akums Life - Derabassi",
    GSTIN: "03AAECP0713G1Z1",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9782",
    name: "Akums Life – LALRU",
    GSTIN: "03AAECP0713G1Z1",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9700",
    businessArea: "9783",
    name: "Akums Life – Barwala",
    GSTIN: "06AAECP0713G1ZV",
    PAN: "AAECP0713G",
  },
  {
    company_code: "9800",
    businessArea: "9800",
    name: "Unosource - Mumbai",
    GSTIN: "27AABCU6640G1ZB",
    PAN: "AABCU6640G",
  },
  {
    company_code: "9900",
    businessArea: "9900",
    name: "UPADHRISH RESERCHEM LLP",
    GSTIN: "05AACFU9395C1Z0",
    PAN: "AACFU9395C",
  },
  {
    company_code: "1000",
    businessArea: "0840",
    name: "R&D-4",
    GSTIN: "05AAECA7090B1Z2",
    PAN: "AAECA7090B",
  },
];

export const glAccounts = [
  { account: "40071111", description: "Consumption - Equipment Manual" },
  { account: "40201111", description: "Consumption - FG Inhouse Manual" },
  {
    account: "40401111",
    description: "Consumption - Raw materials IND Manual",
  },
  { account: "40501111", description: "Consumption - Packing Mat IND Manual" },
  { account: "40602200", description: "EHS Expenses" },
  { account: "40701111", description: "Consumption - Consumables IND Manual" },
  { account: "40703111", description: "Consumption - Consumable Q.C Manual" },
  { account: "40705111", description: "Consumption - IT Mat Manual" },
  { account: "40709811", description: "Consumption - Fuel IND Manual" },
  { account: "40773711", description: "Consumption Liquid Nitrogen Manual" },
  { account: "42400050", description: "Power & Fuel Expenses" },
  { account: "42400100", description: "Electricity Expenses" },
  { account: "42400110", description: "Electricity Expenses-Kundli Warehouse" },
  { account: "42400120", description: "Fuel Handling & Ash removal" },
  { account: "42400150", description: "Fuel Expenses" },
  { account: "42400151", description: "Custom Duty" },
  { account: "42400152", description: "Roller Charges/Plat Charges" },
  { account: "42400155", description: "Demurrage Charges" },
  {
    account: "42400165",
    description: "Clearing & Forwarding Charges - Import",
  },
  { account: "42400175", description: "Interest Paid (Custom Duty)" },
  { account: "42400250", description: "Packing Expenses" },
  { account: "42400350", description: "Cartage Inward" },
  { account: "42400351", description: "Cartage Exp (Inward)" },
  { account: "42400360", description: "Job Work" },
  { account: "42400400", description: "Testing Charges" },
  { account: "42900090", description: "Medical Expenses" },
  { account: "42900113", description: "Director Sitting Fees" },
  { account: "42900130", description: "Staff Welfare Expenses" },
  { account: "42900131", description: "Canteen Expenses" },
  { account: "42900132", description: "Meal Allowance" },
  { account: "42900140", description: "Training Expenses" },
  { account: "42900151", description: "Training and Conference Expenses" },
  {
    account: "42900160",
    description: "Labour & Contractor (With Service Tax)",
  },
  {
    account: "42900161",
    description: "Labour & Contractor (Without Service Tax)",
  },
  { account: "42900170", description: "Worker's Group Medical Insurance" },
  {
    account: "42900181",
    description: "Reimbursement of Books and Periodicals",
  },
  { account: "42900183", description: "Telephone Remburisment (Staff)" },
  { account: "42900190", description: "Director Rembursment-Other Exp." },
  { account: "42900195", description: "Leave Travel Allowance" },
  { account: "42900200", description: "Driver Salary Reimbursement" },
  { account: "42900220", description: "LWF contribution - Employer" },
  { account: "42900240", description: "NPS Contribution Employer Share" },
  { account: "42900250", description: "Gift Voucher" },
  { account: "45000050", description: "Cartage Outward" },
  { account: "45000100", description: "Cartage Expenses (Outward)" },
  { account: "45000200", description: "Advertisement & Publicity" },
  { account: "45000210", description: "Liquidated Damages" },
  {
    account: "45000270",
    description: "Regulatory & Product dev. Approval Expenses",
  },
  { account: "45000300", description: "Books & Periodicals" },
  { account: "45000350", description: "Business Promotion" },
  { account: "45000355", description: "Medicine Sample" },
  { account: "45000400", description: "Charity & Donations" },
  {
    account: "45000450",
    description: "Clearing & Forwarding Charges - Export",
  },
  { account: "45000451", description: "Loading Unloading Charges" },
  { account: "45000460", description: "Commission on Sales" },
  { account: "45000650", description: "Conveyance Expenses" },
  { account: "45000700", description: "Fees & Subscription" },
  { account: "45000701", description: "Audit Fees" },
  { account: "45000710", description: "Business Support Services" },
  { account: "45000750", description: "Fees & Subscription (Foreign)" },
  { account: "45000800", description: "Festival Expenses" },
  { account: "45000950", description: "HouseKeeping Expenses" },
  { account: "45000960", description: "Guest House Expenses" },
  { account: "45001000", description: "Insurance Expenses" },
  { account: "45001050", description: "Lease Rent Paid" },
  { account: "45001100", description: "Legal & Professional Expenses" },
  { account: "45001150", description: "Liasoning Charges Paid" },
  { account: "45001200", description: "Misc. Expenses" },
  { account: "45001250", description: "Pooja Expenses" },
  { account: "45001300", description: "Postage & Telegram Expenses" },
  { account: "45001350", description: "Printing & Stationery" },
  { account: "45001410", description: "Bonus Paid- Labour Contractor" },
  { account: "45001550", description: "Security Expenses" },
  { account: "45001600", description: "Stamp Paper & Notary Expenses" },
  { account: "45001601", description: "Staff Recruitment Exp" },
  { account: "45001650", description: "Sundry Balance Written off" },
  { account: "45001700", description: "Telephone Expenses" },
  { account: "45001701", description: "Water Expenses" },
  { account: "45001702", description: "Networking Expenses" },
  { account: "45001750", description: "Travelling Expense-Others" },
  { account: "45001800", description: "Travelling Expenses" },
  { account: "45001801", description: "Travelling Expenses (Foreign Tour)" },
  { account: "45001850", description: "Uniform Expenses" },
  {
    account: "45001900",
    description: "Vehicle Running & Maintenance Expenses",
  },
  { account: "45001960", description: "Property Tax" },
  { account: "45001961", description: "Reimbursement Conveyance (Staff)" },
  { account: "45001962", description: "Office Maintenance" },
  { account: "45001963", description: "Horticulture" },
  { account: "45001965", description: "Vehicle Hire Charges" },
  { account: "45001966", description: "Uniform Washing Expenses" },
  { account: "45001967", description: "Software Maintenance Expneses" },
  { account: "45001970", description: "Donations" },
  { account: "45001980", description: "Gifts" },
  { account: "45002000", description: "DRA – Fees & subscription" },
  { account: "45002010", description: "DRA – Legal & professional expenses" },
  { account: "46000010", description: "Interest Paid To Bank ( For CC)" },
  { account: "46000020", description: "Interest Paid (On Short Term Loan)" },
  { account: "46000050", description: "Interest Paid (On Term Loan)" },
  { account: "46000080", description: "Interest Paid (TL No. 31159228617)" },
  { account: "46000090", description: "Interest Paid on Term Loan (ICICI)" },
  { account: "46000100", description: "Bank Charges" },
  { account: "46000105", description: "Bank Guarantee charges" },
  { account: "46000170", description: "Interest on Intercompany loan" },
  { account: "46000175", description: "Corporate Guarantee commission" },
  { account: "46000180", description: "Interest paid- RXIL" },
  { account: "46000200", description: "Interest & Penalties" },
  { account: "49000099", description: "Rounding off - General" },
  { account: "49000101", description: "Freight & Cartage" },
  { account: "49005300", description: "CGST under RCM" },
  { account: "49005310", description: "SGST under RCM" },
  { account: "49005320", description: "IGST under RCM" },
  { account: "49005500", description: "Rent Paid" },
  { account: "49005502", description: "Electricity Expenses for Guest House" },
  { account: "49005505", description: "Rent Paid-Kundli Warehouse" },
  { account: "49006000", description: "Repairs to buildings" },
  { account: "49006010", description: "Repairs to machinery" },
  { account: "49006020", description: "Repairs to vehicles" },
  { account: "49006030", description: "Repairs to computers" },
  { account: "49006040", description: "Repairs to Other" },
  { account: "49006045", description: "Prior Period Exp." },
  { account: "49006050", description: "Repairs to Electrical" },
  { account: "49006060", description: "Repairs to Furniture" },
  { account: "49006070", description: "Repairs to Q.C Equipments" },
  { account: "49006090", description: "Corporate Social Responsibilty" },
  { account: "49006100", description: "Pollution Control Expenses" },
  { account: "49006110", description: "Calibration of Instruments Charges" },
];

// export const taxCodes = [
//   {
//     "value": "A0",
//     "label": "A/P Zero",
//     "Process": "Marcan"
//   },
//   {
//     "value": "A1",
//     "label": "GST + (PST/HST)",
//     "Process": "Marcan"
//   },
//   {
//     "value": "A2",
//     "label": "GST + QST",
//     "Process": "Marcan"
//   },
//   {
//     "value": "A4",
//     "label": "Import",
//     "Process": "Marcan"
//   },
//   {
//     "value": "GJ",
//     "label": "A/P, GST applicable, PST exempt",
//     "Process": "Marcan"
//   },
//   {
//     "value": "IJ",
//     "label": "A/P, GST applicable, PST applicable",
//     "Process": "Marcan"
//   },
//   {
//     "value": "PJ",
//     "label": "A/P, GST exempt, PST applicable",
//     "Process": "Marcan"
//   },
//   {
//     "value": "SJ",
//     "label": "A/P, Self assess GST and PST",
//     "Process": "Marcan"
//   },
//   {
//     "value": "T0",
//     "label": "International Travel (No Recovery)",
//     "Process": "Marcan"
//   },
//   {
//     "value": "T1",
//     "label": "General Travel Expense (Non-Food)",
//     "Process": "Marcan"
//   },
//   {
//     "value": "T2",
//     "label": "Meals and Entertainment (50%)",
//     "Process": "Marcan"
//   },
//   {
//     "value": "T3",
//     "label": "mIleage",
//     "Process": "Marcan"
//   },
//   {
//     "value": "T4",
//     "label": "Rental Car Gas",
//     "Process": "Marcan"
//   },
//   {
//     "value": "99",
//     "label": "Fuori campo acquisti 0%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A0",
//     "label": "Input Tax 0%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A1",
//     "label": "Art. 71 Presidential Decree 633/72 art. 8, co. 1",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A2",
//     "label": "Minimum taxpayer regime excluded",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A3",
//     "label": "Excluding Art. 2",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A4",
//     "label": "Excluding Art. 15",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A5",
//     "label": "Art. 1, Law 190/2014",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A6",
//     "label": "Exempt Art. 124",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A7",
//     "label": "Art. 21, paragraph 4, letter a)",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A8",
//     "label": "Art. 26 C.3-4",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A9",
//     "label": "Art. 71 Presidential Decree 26/10/1972 No. 633",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AA",
//     "label": "VAT 4%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AB",
//     "label": "VAT 4% Non-deductible 100%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AC",
//     "label": "VAT 5%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AD",
//     "label": "VAT 5% Non-deductible 100%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AE",
//     "label": "VAT 10%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AF",
//     "label": "VAT 10% U.E. Purchases",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AG",
//     "label": "VAT 10% U.E. Purchases Services",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AH",
//     "label": "VAT 10% Purchases Extra U.E.",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AI",
//     "label": "VAT 10% Non-deductible 50%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AJ",
//     "label": "VAT 10% Non-deductible 100%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AK",
//     "label": "VAT 22%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AL",
//     "label": "VAT 22% Non-deductible 50%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AM",
//     "label": "VAT 22% Non-deductible 60%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AN",
//     "label": "VAT 22% Non-deductible 100%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AO",
//     "label": "VAT 22% U.E. Purchases",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AP",
//     "label": "VAT 22% U.E. Purchases Services",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AQ",
//     "label": "VAT 22% Purchases Extra U.E.",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AR",
//     "label": "art.17 paragraph 6 D.P.R. 633/72",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AS",
//     "label": "Exempt Article 17 C.",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AT",
//     "label": "Not Imp. Art. 8a",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AU",
//     "label": "Not Imp. Art. 8b",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AV",
//     "label": "Not Imp. Art. 9",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AW",
//     "label": "Not Imp. Art. 41 EU sales",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AX",
//     "label": "Purchases Plafond Art. 8",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AY",
//     "label": "Exempt Art. 10 DPR 622/72",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "AZ",
//     "label": "Out of VAT",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "BA",
//     "label": "VAT 22% Non-deductible 30%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "E0",
//     "label": "IVA acquisti 0%, Art. 9",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "I9",
//     "label": "19% input tax (Italy), 50% nondeductible",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "IA",
//     "label": "VAT paid Art. 74",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "IT",
//     "label": "IVA ventilazione",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "X1",
//     "label": "IVA acquisti CEE 10%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "X4",
//     "label": "4% EC acquisition (Italy)",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "X9",
//     "label": "IVA acquisti CEE 19%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "Z1",
//     "label": "Reverse Charge Input VAT - 10%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A0",
//     "label": "A/P Zero",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A1",
//     "label": "A/P VAT 5%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A2",
//     "label": "A/P VAT 7%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A3",
//     "label": "A/P VAT 18%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "E0",
//     "label": "A/P Sales Tax, exempt",
//     "Process": "Avet"
//   },
//   {
//     "value": "E1",
//     "label": "A/P Sales Tax, taxable, posted to Cost Account",
//     "Process": "Avet"
//   },
//   {
//     "value": "I0",
//     "label": "A/P Sales Tax, exempt",
//     "Process": "Avet"
//   },
//   {
//     "value": "I1",
//     "label": "A/P Sales Tax, taxable, distributed to line items",
//     "Process": "Avet"
//   },
//   {
//     "value": "U0",
//     "label": "A/P Use Tax, exempt",
//     "Process": "Avet"
//   },
//   {
//     "value": "U1",
//     "label": "A/P Use Tax, taxable, self assessed",
//     "Process": "Avet"
//   },
//   {
//     "value": "V0",
//     "label": "Input 0% Tax",
//     "Process": "Avet"
//   },
//   {
//     "value": "V0",
//     "label": "A/P : Zero% VAT",
//     "Process": "Emerging"
//   },
//   {
//     "value": "V1",
//     "label": "A/P : 5% VAT",
//     "Process": "Emerging"
//   },
//   {
//     "value": "V2",
//     "label": "A/P : 5% VAT - ND",
//     "Process": "Emerging"
//   },
//   {
//     "value": "V3",
//     "label": "AP: VAT RCM 5 %",
//     "Process": "Emerging"
//   },
//   {
//     "value": "V0",
//     "label": "Input Tax Zero %",
//     "Process": "Emerging"
//   },
//   {
//     "value": "V1",
//     "label": "Input Tax 16 %",
//     "Process": "Emerging"
//   },
//   {
//     "value": "V0",
//     "label": "Input Tax Zero %",
//     "Process": "Emerging"
//   },
//   {
//     "value": "V1",
//     "label": "Input Tax 19 %",
//     "Process": "Emerging"
//   },
//   {
//     "value": "A0",
//     "label": "0% Vat Purchase",
//     "Process": "Emerging"
//   },
//   {
//     "value": "A1",
//     "label": "18% Vat Purchase",
//     "Process": "Emerging"
//   },
//   {
//     "value": "A0",
//     "label": "A/P Zero",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A1",
//     "label": "A/P VAT 20%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A2",
//     "label": "A/P VAT 5%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A3",
//     "label": "A/P VAT Exempted",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A4",
//     "label": "A/P VAT 12.5%",
//     "Process": "Tillomed"
//   },
//   {
//     "value": "A0",
//     "label": "A/P Zero",
//     "Process": "Emerging"
//   },
//   {
//     "value": "A1",
//     "label": "A/P VAT 18%",
//     "Process": "Emerging"
//   },
//   {
//     "value": "P3",
//     "label": "",
//     "Process": "Emerging"
//   },
//   {
//     "value": "V0",
//     "label": "Input Tax Zero %",
//     "Process": "Emerging"
//   },
//   {
//     "value": "V1",
//     "label": "Input Tax 12 %",
//     "Process": "Emerging"
//   },
//   {
//     "value": "A0",
//     "label": "A/P Zero",
//     "Process": "Emerging"
//   },
//   {
//     "value": "A1",
//     "label": "A/P VAT 14%",
//     "Process": "Emerging"
//   },
//   {
//     "value": "A2",
//     "label": "A/P VAT 15%",
//     "Process": "Emerging"
//   },
//   {
//     "value": "B0",
//     "label": "CST No Setoff - ED",
//     "Process": "Domestic"
//   },
//   {
//     "value": "B1",
//     "label": "CST Set Off ED - Cenvat Availment",
//     "Process": "Domestic"
//   },
//   {
//     "value": "B2",
//     "label": "CST ED - Sales in Transit",
//     "Process": "Domestic"
//   },
//   {
//     "value": "B3",
//     "label": "CST ND - Sales in Transit",
//     "Process": "Domestic"
//   },
//   {
//     "value": "B4",
//     "label": "CST No Setoff - ND",
//     "Process": "Domestic"
//   },
//   {
//     "value": "B5",
//     "label": "CST Set Off - ND",
//     "Process": "Domestic"
//   },
//   {
//     "value": "B6",
//     "label": "Import Purchase - ED",
//     "Process": "Domestic"
//   },
//   {
//     "value": "B7",
//     "label": "Import Purchase - ND",
//     "Process": "Domestic"
//   },
//   {
//     "value": "B8",
//     "label": "VAT 4% Retention Capital Set Off ND",
//     "Process": "Domestic"
//   },
//   {
//     "value": "B9",
//     "label": "VAT Capital Set Off ED",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BA",
//     "label": "VAT Capital Set Off ND",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BB",
//     "label": "VAT EOU Set Off - ED",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BC",
//     "label": "VAT EOU Set Off - ND",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BD",
//     "label": "VAT Full Set Off - ND - CFA Purchase",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BE",
//     "label": "VAT Full Set Off - ND - Gujrat Purchase",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BF",
//     "label": "VAT Full Set Off - ND - Sikkim Purchase",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BG",
//     "label": "VAT No Set Off - ED",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BH",
//     "label": "VAT No Set Off - ND",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BI",
//     "label": "VAT No Set Off - ND - CFA Purchase",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BJ",
//     "label": "VAT Set Off ED",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BK",
//     "label": "VAT Setoff ND",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BL",
//     "label": "GTA 14% of 30% of basic + SB + KK",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BM",
//     "label": "Service Tax 5.80- No SO + 8% VAT(S/O)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BN",
//     "label": "ST 14% on 40% Basic (Rent Cab) + SB + KK",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BO",
//     "label": "ST 14.5% on 50% on 40%+VAT 12.5% or 5% or 8%",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BP",
//     "label": "WCT-ST 14.50% on 40% Basic+VAT 5.00%  OR 8%",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BQ",
//     "label": "WCT-ST14.50% on 40%-50% Basic VAT 12.50%OR5%OR8%",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BR",
//     "label": "ST14% on 60% of basic & VAT + SB + KK (Catering)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BS",
//     "label": "ST 14.5 % on 70% basic + VAT",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BT",
//     "label": "ST 14.5 % on 50% on 70% + VAT",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BU",
//     "label": "ST 14.50%ON 70% BASIC+VAT 8% ON BASIC + ST",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BV",
//     "label": "ST 14.50%on70% Basic+VAT 5.00%  (Corporate Vendor)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BW",
//     "label": "WCT-ST 14.50% on 70% Basic+CST 5% on 30% Basic",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BX",
//     "label": "ST- 14.5 % on 40% . No VAT",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BY",
//     "label": "ST-14.00 (Foreign Payment) + SB + KK",
//     "Process": "Domestic"
//   },
//   {
//     "value": "BZ",
//     "label": "Service Tax 14.5 % on basic + VAT",
//     "Process": "Domestic"
//   },
//   {
//     "value": "C0",
//     "label": "Service Tax 14% (Exp & Payable) +SB+KK",
//     "Process": "Domestic"
//   },
//   {
//     "value": "C1",
//     "label": "Service Tax 14.50- No Setoff",
//     "Process": "Domestic"
//   },
//   {
//     "value": "C2",
//     "label": "Ser Tax on 14% of Basic Value + SB + KK (Manpower)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "C3",
//     "label": "ST 14% on 70% on 50% Basic + SB+ VAT",
//     "Process": "Domestic"
//   },
//   {
//     "value": "C4",
//     "label": "WCT-ST 14% on 40% of basic + SB + KK",
//     "Process": "Domestic"
//   },
//   {
//     "value": "C5",
//     "label": "ST 14% on 50% on 40% +SB+KK VAT+ ( WCT N-Payable)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "C6",
//     "label": "WCT-ST 14% on 40% Basic+ SB + KK + VAT",
//     "Process": "Domestic"
//   },
//   {
//     "value": "C7",
//     "label": "WCT-ST 14% on 40%-50% Basic+ SB+ KK( WCT R Payable",
//     "Process": "Domestic"
//   },
//   {
//     "value": "C8",
//     "label": "WCT-ST 14% on 70% Basic+SB+KK+VAT (Corp Vendor)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "C9",
//     "label": "WCT-ST 14%  50%-70% + SB+ KK + VAT(WCT R Payable)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CA",
//     "label": "WCT-ST 14%-70%-50% Basic+SB+KK+VAT+ (WCT R-Payable",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CB",
//     "label": "ST 14% on70% Basic+SB+KK+VAT (Corp Vendor)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CC",
//     "label": "WCT-ST-14% on 70% Basic + SB + KK + VAT",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CD",
//     "label": "ST- 14 % -40% -50% of Basic + SB+KK (WCT N Payable",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CE",
//     "label": "Servivce Tax 14%  + SB + KK + VAT (MFG)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CF",
//     "label": "Service Tax 14% + SB + KK- No Setoff",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CG",
//     "label": "ST 14% on 70% on 50% Basic + SB+ KK+VAT",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CH",
//     "label": "ISD-SERVICE TAX 14% PAYABLE+SB+KK",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CI",
//     "label": "ISD-WCT-ST 14%ON 40% BASIC+SB+KK+VAT",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CJ",
//     "label": "ISD-ST-14%-40%-50%+SB+KK-WCT N PAYABLE",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CK",
//     "label": "ISD-WCT-ST-14%ON 70% BASIC+SB+KK+VAT",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CL",
//     "label": "ISD-SERVICE TAX 14% +SB+KK",
//     "Process": "Domestic"
//   },
//   {
//     "value": "CM",
//     "label": "ISD-WCT-ST-14% 50%-70%+SB+KK+VAT (WCT R PAYABLE)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "D0",
//     "label": "FORM H",
//     "Process": "Domestic"
//   },
//   {
//     "value": "D1",
//     "label": "GUJRATH CAPITAL VAT S/O-ED",
//     "Process": "Domestic"
//   },
//   {
//     "value": "D2",
//     "label": "GUJRATH CAPITAL VAT S/O-ND",
//     "Process": "Domestic"
//   },
//   {
//     "value": "D3",
//     "label": "High Seas Sale ND",
//     "Process": "Domestic"
//   },
//   {
//     "value": "D4",
//     "label": "High Seas Sale ED",
//     "Process": "Domestic"
//   },
//   {
//     "value": "D5",
//     "label": "VAT Full Set Off - ND - Karnatak Purchase",
//     "Process": "Domestic"
//   },
//   {
//     "value": "D6",
//     "label": "VAT Full Set Off - ED - Karnatak Purchase",
//     "Process": "Domestic"
//   },
//   {
//     "value": "E1",
//     "label": "Input CGST+SGST-With 5% (Against Form A)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "E2",
//     "label": "Input CGST+SGST-With 12% (Against Form A)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "E3",
//     "label": "Input CGST+SGST-With 18% (Against Form A)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "E4",
//     "label": "Input CGST+SGST-With 28% (Against Form A)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "E5",
//     "label": "Input IGST-With 5% (Against Form A)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "E6",
//     "label": "Input IGST-With 12% (Against Form A)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "E7",
//     "label": "Input IGST-With 18% (Against Form A)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "E8",
//     "label": "Input IGST-With 28% (Against Form A)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "E9",
//     "label": "Input IGST-With 40 % (Against Form A)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "EB",
//     "label": "Input CGST+SGST-With 40% (Against Form A)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "I1",
//     "label": "Input IGST - With Different %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "I2",
//     "label": "Input IGST - With 0 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "I3",
//     "label": "Input IGST - With 5 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "I4",
//     "label": "Input IGST - With 12 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "I5",
//     "label": "Input IGST - With 18 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "I6",
//     "label": "Input IGST - With 28 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "I7",
//     "label": "Input IGST - With 0.10 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "I8",
//     "label": "Input IGST - With 40 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "IA",
//     "label": "Input CGST + SGST - With Different %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "IB",
//     "label": "IMPORTS - IGST DEDUCTIBLE",
//     "Process": "Domestic"
//   },
//   {
//     "value": "IC",
//     "label": "IMPORTS - IGST NON DEDUCTIBLE",
//     "Process": "Domestic"
//   },
//   {
//     "value": "ID",
//     "label": "Form A -Input IGST",
//     "Process": "Domestic"
//   },
//   {
//     "value": "IE",
//     "label": "Form A -Input CGST/SGST",
//     "Process": "Domestic"
//   },
//   {
//     "value": "IF",
//     "label": "Input CGST + SGST - With 0 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "IG",
//     "label": "Input CGST + SGST - With 5 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "IH",
//     "label": "Input CGST + SGST - With 12 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "II",
//     "label": "Input CGST + SGST - With 18 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "IJ",
//     "label": "Input CGST + SGST - With 28 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "IK",
//     "label": "Input CGST + SGST - With 40 %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "J1",
//     "label": "CGST + SGST : TCS 0.075% On (Basic)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "J2",
//     "label": "CGST + SGST : TCS 0.075% On (Basic+GST)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "J3",
//     "label": "IGST : TCS .075% on (BASIC +IGST)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "J4",
//     "label": "IGST : TCS 0.075% On Basic",
//     "Process": "Domestic"
//   },
//   {
//     "value": "J5",
//     "label": "CGST + SGST : TCS 0.1% On (Basic)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "J6",
//     "label": "CGST + SGST : TCS 0.1 On (Basic+GST)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "J7",
//     "label": "IGST : TCS 0.1% on (BASIC +IGST)",
//     "Process": "Domestic"
//   },
//   {
//     "value": "J8",
//     "label": "IGST : TCS 0.1% On Basic",
//     "Process": "Domestic"
//   },
//   {
//     "value": "N0",
//     "label": "NON GST Purchase",
//     "Process": "Domestic"
//   },
//   {
//     "value": "R1",
//     "label": "Input RCM - IGST - With Different %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "R2",
//     "label": "Input RCM - IGST - With Different % - No Set Off",
//     "Process": "Domestic"
//   },
//   {
//     "value": "R4",
//     "label": "Input IGST - With 5 % RC WC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "R5",
//     "label": "Input IGST - With 12 % RC WC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "R6",
//     "label": "Input IGST - With 18 % RC WC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "R7",
//     "label": "Input IGST - With 28 % RC WC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "R8",
//     "label": "Input IGST - With 40 % RC WC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "R9",
//     "label": "Input IGST - With 5 % RC WoC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RA",
//     "label": "Input RCM - CGST + SGST - With Different %",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RB",
//     "label": "Input RCM - CGST + SGST - With Different % - No Se",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RD",
//     "label": "Input CGST + SGST - With 5 % RC WC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RE",
//     "label": "Input CGST + SGST - With 12 % RC WC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RF",
//     "label": "Input CGST + SGST - With 18 % RC WC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RG",
//     "label": "Input CGST + SGST - With 28 % RC WC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RH",
//     "label": "Input CGST + SGST - With 40 % RC WC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RI",
//     "label": "Input CGST + SGST - With 5 % (FI Only)RC WoC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RJ",
//     "label": "Input CGST + SGST - With 12 % (FI Only)RC WoC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RK",
//     "label": "Input CGST + SGST - With 18 % (FI Only)RC WoC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RL",
//     "label": "Input CGST + SGST - With 28 % (FI Only)RC WoC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RM",
//     "label": "Input IGST - With 12 % (FI Only)RC WoC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RN",
//     "label": "Input IGST - With 18 % (FI Only)RC WoC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "RO",
//     "label": "Input IGST - With 28 % (FI Only)RC WoC",
//     "Process": "Domestic"
//   },
//   {
//     "value": "S0",
//     "label": "Service Tax - No Setoff",
//     "Process": "Domestic"
//   },
//   {
//     "value": "V0",
//     "label": "I/P Zero Tax",
//     "Process": "Domestic"
//   }
// ]

export const taxCodes = [
  {
    value: "A0",
    label: "A/P Zero",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "A1",
    label: "GST + (PST/HST)",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "A2",
    label: "GST + QST",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "A4",
    label: "Import",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "GJ",
    label: "A/P, GST applicable, PST exempt",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "IJ",
    label: "A/P, GST applicable, PST applicable",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "PJ",
    label: "A/P, GST exempt, PST applicable",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "SJ",
    label: "A/P, Self assess GST and PST",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "T0",
    label: "International Travel (No Recovery)",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "T1",
    label: "General Travel Expense (Non-Food)",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "T2",
    label: "Meals and Entertainment (50%)",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "T3",
    label: "mIleage",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "T4",
    label: "Rental Car Gas",
    Country: "CA",
    "Country Name": "Canada",
    Process: "Marcan",
    companyCode: "MPI ,MNPI",
  },
  {
    value: "99",
    label: "Fuori campo acquisti 0%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "A0",
    label: "Input Tax 0%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "A1",
    label: "Art. 71 Presidential Decree 633/72 art. 8, co. 1",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "A2",
    label: "Minimum taxpayer regime excluded",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "A3",
    label: "Excluding Art. 2",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "A4",
    label: "Excluding Art. 15",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "A5",
    label: "Art. 1, Law 190/2014",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "A6",
    label: "Exempt Art. 124",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "A7",
    label: "Art. 21, paragraph 4, letter a)",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "A8",
    label: "Art. 26 C.3-4",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "A9",
    label: "Art. 71 Presidential Decree 26/10/1972 No. 633",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AA",
    label: "VAT 4%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AB",
    label: "VAT 4% Non-deductible 100%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AC",
    label: "VAT 5%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AD",
    label: "VAT 5% Non-deductible 100%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AE",
    label: "VAT 10%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AF",
    label: "VAT 10% U.E. Purchases",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AG",
    label: "VAT 10% U.E. Purchases Services",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AH",
    label: "VAT 10% Purchases Extra U.E.",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AI",
    label: "VAT 10% Non-deductible 50%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AJ",
    label: "VAT 10% Non-deductible 100%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AK",
    label: "VAT 22%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AL",
    label: "VAT 22% Non-deductible 50%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AM",
    label: "VAT 22% Non-deductible 60%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AN",
    label: "VAT 22% Non-deductible 100%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AO",
    label: "VAT 22% U.E. Purchases",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AP",
    label: "VAT 22% U.E. Purchases Services",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AQ",
    label: "VAT 22% Purchases Extra U.E.",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AR",
    label: "art.17 paragraph 6 D.P.R. 633/72",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AS",
    label: "Exempt Article 17 C.",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AT",
    label: "Not Imp. Art. 8a",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AU",
    label: "Not Imp. Art. 8b",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AV",
    label: "Not Imp. Art. 9",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AW",
    label: "Not Imp. Art. 41 EU sales",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AX",
    label: "Purchases Plafond Art. 8",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AY",
    label: "Exempt Art. 10 DPR 622/72",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "AZ",
    label: "Out of VAT",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "BA",
    label: "VAT 22% Non-deductible 30%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "E0",
    label: "IVA acquisti 0%, Art. 9",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "I9",
    label: "19% input tax (Italy), 50% nondeductible",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "IA",
    label: "VAT paid Art. 74",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "IT",
    label: "IVA ventilazione",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "X1",
    label: "IVA acquisti CEE 10%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "X4",
    label: "4% EC acquisition (Italy)",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "X9",
    label: "IVA acquisti CEE 19%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "Z1",
    label: "Reverse Charge Input VAT - 10%",
    Country: "IT",
    "Country Name": "Italy",
    Process: "Tillomed",
    companyCode: "TII",
  },
  {
    value: "A0",
    label: "A/P Zero",
    Country: "MT",
    "Country Name": "Malta",
    Process: "Tillomed",
    companyCode: "TIM",
  },
  {
    value: "A1",
    label: "A/P VAT 5%",
    Country: "MT",
    "Country Name": "Malta",
    Process: "Tillomed",
    companyCode: "TIM",
  },
  {
    value: "A2",
    label: "A/P VAT 7%",
    Country: "MT",
    "Country Name": "Malta",
    Process: "Tillomed",
    companyCode: "TIM",
  },
  {
    value: "A3",
    label: "A/P VAT 18%",
    Country: "MT",
    "Country Name": "Malta",
    Process: "Tillomed",
    companyCode: "TIM",
  },
  {
    value: "E0",
    label: "A/P Sales Tax, exempt",
    Country: "US",
    "Country Name": "USA",
    Process: "Avet",
    companyCode: "EUS",
  },
  {
    value: "E1",
    label: "A/P Sales Tax, taxable, posted to Cost Account",
    Country: "US",
    "Country Name": "USA",
    Process: "Avet",
    companyCode: "EUS",
  },
  {
    value: "I0",
    label: "A/P Sales Tax, exempt",
    Country: "US",
    "Country Name": "USA",
    Process: "Avet",
    companyCode: "EUS",
  },
  {
    value: "I1",
    label: "A/P Sales Tax, taxable, distributed to line items",
    Country: "US",
    "Country Name": "USA",
    Process: "Avet",
    companyCode: "EUS",
  },
  {
    value: "U0",
    label: "A/P Use Tax, exempt",
    Country: "US",
    "Country Name": "USA",
    Process: "Avet",
    companyCode: "EUS",
  },
  {
    value: "U1",
    label: "A/P Use Tax, taxable, self assessed",
    Country: "US",
    "Country Name": "USA",
    Process: "Avet",
    companyCode: "EUS",
  },
  {
    value: "V0",
    label: "Input 0% Tax",
    Country: "US",
    "Country Name": "USA",
    Process: "Avet",
    companyCode: "EUS",
  },
  {
    value: "V0",
    label: "A/P : Zero% VAT",
    Country: "AE",
    "Country Name": "Utd.Arab Emir.",
    Process: "Emerging",
    companyCode: "EMN",
  },
  {
    value: "V1",
    label: "A/P : 5% VAT",
    Country: "AE",
    "Country Name": "Utd.Arab Emir.",
    Process: "Emerging",
    companyCode: "EMN",
  },
  {
    value: "V2",
    label: "A/P : 5% VAT - ND",
    Country: "AE",
    "Country Name": "Utd.Arab Emir.",
    Process: "Emerging",
    companyCode: "EMN",
  },
  {
    value: "V3",
    label: "AP: VAT RCM 5 %",
    Country: "AE",
    "Country Name": "Utd.Arab Emir.",
    Process: "Emerging",
    companyCode: "EMN",
  },
  {
    value: "V0",
    label: "Input Tax Zero %",
    Country: "KE",
    "Country Name": "Kenya",
    Process: "Emerging",
    companyCode: "LPK",
  },
  {
    value: "V1",
    label: "Input Tax 16 %",
    Country: "KE",
    "Country Name": "Kenya",
    Process: "Emerging",
    companyCode: "LPK",
  },
  {
    value: "V0",
    label: "Input Tax Zero %",
    Country: "CL",
    "Country Name": "Chile",
    Process: "Emerging",
    companyCode: "EPC",
  },
  {
    value: "V1",
    label: "Input Tax 19 %",
    Country: "CL",
    "Country Name": "Chile",
    Process: "Emerging",
    companyCode: "EPC",
  },
  {
    value: "A0",
    label: "0% Vat Purchase",
    Country: "DO",
    "Country Name": "Dominican Rep.",
    Process: "Emerging",
    companyCode: "EPDR",
  },
  {
    value: "A1",
    label: "18% Vat Purchase",
    Country: "DO",
    "Country Name": "Dominican Rep.",
    Process: "Emerging",
    companyCode: "EPDR",
  },
  {
    value: "A0",
    label: "18% Vat Purchase",
    Country: "GB",
    "Country Name": "United Kingdom",
    Process: "Tillomed",
    companyCode: "TIL/EUK",
  },
  {
    value: "A1",
    label: "A/P VAT 20%",
    Country: "GB",
    "Country Name": "United Kingdom",
    Process: "Tillomed",
    companyCode: "TIL/EUK",
  },
  {
    value: "A2",
    label: "A/P VAT 5%",
    Country: "GB",
    "Country Name": "United Kingdom",
    Process: "Tillomed",
    companyCode: "TIL/EUK",
  },
  {
    value: "A3",
    label: "A/P VAT Exempted",
    Country: "GB",
    "Country Name": "United Kingdom",
    Process: "Tillomed",
    companyCode: "TIL/EUK",
  },
  {
    value: "A4",
    label: "A/P VAT 12.5%",
    Country: "GB",
    "Country Name": "United Kingdom",
    Process: "Tillomed",
    companyCode: "TIL/EUK",
  },
  {
    value: "A0",
    label: "A/P Zero",
    Country: "PE",
    "Country Name": "Peru",
    Process: "Emerging",
    companyCode: "EPE",
  },
  {
    value: "A1",
    label: "A/P VAT 18%",
    Country: "PE",
    "Country Name": "Peru",
    Process: "Emerging",
    companyCode: "EPE",
  },
  {
    value: "P3",
    label: "",
    Country: "PE",
    "Country Name": "Peru",
    Process: "Emerging",
    companyCode: "EPE",
  },
  {
    value: "V0",
    label: "Input Tax Zero %",
    Country: "PH",
    "Country Name": "Philippines",
    Process: "Emerging",
    companyCode: "EPH",
  },
  {
    value: "V1",
    label: "Input Tax 12 %",
    Country: "PH",
    "Country Name": "Philippines",
    Process: "Emerging",
    companyCode: "EPH",
  },
  {
    value: "A0",
    label: "A/P Zero",
    Country: "ZA",
    "Country Name": "South Africa",
    Process: "Emerging",
    companyCode: "ESA",
  },
  {
    value: "A1",
    label: "A/P VAT 14%",
    Country: "ZA",
    "Country Name": "South Africa",
    Process: "Emerging",
    companyCode: "ESA",
  },
  {
    value: "A2",
    label: "A/P VAT 15%",
    Country: "ZA",
    "Country Name": "South Africa",
    Process: "Emerging",
    companyCode: "ESA",
  },
  {
    value: "E5",
    label: "Input IGST 5%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "E6",
    label: "Input IGST 12%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "E7",
    label: "Input IGST 18%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "E8",
    label: "Input IGST 28%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "E9",
    label: "Input IGST 40%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "E1",
    label: "Input IGST 5%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "E2",
    label: "Input IGST 12%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "E3",
    label: "Input IGST 18%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "E4",
    label: "Input IGST 28%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "EB",
    label: "Input IGST 40%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "IF",
    label: "Input IGST 0%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "IG",
    label: "Input IGST 5%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "IH",
    label: "Input IGST 12%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "II",
    label: "Input IGST 18%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "IJ",
    label: "Input IGST 28%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "IK",
    label: "Input IGST 40%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "I2",
    label: "Input IGST 0%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "I3",
    label: "Input IGST 5%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "I4",
    label: "Input IGST 12%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "I5",
    label: "Input IGST 18%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "I6",
    label: "Input IGST 28%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "I8",
    label: "Input IGST 40%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "R4",
    label: "R4 5%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "R5",
    label: "R5 12%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "R6",
    label: "R6 18%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "R7",
    label: "R7 28%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "R8",
    label: "R8 40%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "RD",
    label: "RD 5%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "RE",
    label: "RE 12%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "RF",
    label: "RF 18%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "RG",
    label: "RG 28%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
  {
    value: "RH",
    label: "RH 40%",
    companyCode: "EPL, ZHL,EBT, EMCT,ELPL,EWPL",
    Process: "Domestic",
  },
];

export const cost_center = [
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "2101010100",
    Description: "Akums (A-01)_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "2103010100",
    Description: "Akums (A-01)_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "2301010100",
    Description: "Akums (A-01)_Comm._Purchase",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "2601010100",
    Description: "Akums (A-01)_ESG_ESG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "2602010100",
    Description: "Akums (A-01)_ESG_EHS",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "2701010100",
    Description: "Akums (A-01)_Engg_Maintenance",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "2702010100",
    Description: "Akums (A-01)_Engg_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "2702020100",
    Description: "Akums (A-01)_Engg_DG Set",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "2702030100",
    Description: "Akums (A-01)_Engg_Boiler",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "2904010100",
    Description: "Akums (A-01)_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3001010100",
    Description: "Akums (A-01)_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3101010100",
    Description: "Akums (A-01)_Operations",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3201010100",
    Description: "OE_A-01",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3501010100",
    Description: "Akums (A-01)_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3502010100",
    Description: "Akums (A-01)_QA_IPQA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3503010100",
    Description: "Akums (A-01)_QA_CQA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3601010100",
    Description: "Akums (A-01)_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3701010100",
    Description: "Akums (A-01)_R&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3801010100",
    Description: "Akums (A-01)_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3802010100",
    Description: "Akums (A-01)_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3803010100",
    Description: "Akums (A-01)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3804010100",
    Description: "Akums (A-01)_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3805010100",
    Description: "Akums (A-01)_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3806010100",
    Description: "WH A-09 (Plant 1)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "3901010100",
    Description: "Akums (A-01)_SCM_PPIC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "4101010100",
    Description: "Akums (A-01)_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "5101010100",
    Description: "Akums (A-01)_Production",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "6001010100",
    Description: "Akums (A-01)_Dep_Ind-Lease Hold Land",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "6002010100",
    Description: "Akums (A-01)_Dep_Ind-Building",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "6003010100",
    Description: "Akums (A-01)_Dep_Ind-P & M",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "6004010100",
    Description: "Akums (A-01)_Dep_Ind-Elect.Instalat",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "6005010100",
    Description: "Akums (A-01)_Dep_Ind-Lab.equipments",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "6006010100",
    Description: "Akums (A-01)_Dep_Ind-F & F",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "6007010100",
    Description: "Akums (A-01)_Dep_Ind-Office Equipment",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "6008010100",
    Description: "Akums (A-01)_Dep_Ind-Pol. Cont.Equ.",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0100",
    CostCenter: "6009010100",
    Description: "Akums (A-01)_Dep_Ind-Vehicle",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "2101010200",
    Description: "Akums (A-02)_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "2103010200",
    Description: "Akums (A-02)_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "2301010200",
    Description: "Akums (A-02)_Comm._Purchase",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "2601010200",
    Description: "Akums (A-02)_ESG_ESG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "2602010200",
    Description: "Akums (A-02)_ESG_EHS",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "2701010200",
    Description: "Akums (A-02)_Engg_Maintenance",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "2702010200",
    Description: "Akums (A-02)_Engg_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "2702020200",
    Description: "Akums (A-02)_Engg_DG Set",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "2702030200",
    Description: "Akums (A-02)_Engg_Boiler",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "2904010200",
    Description: "Akums (A-02)_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3001010200",
    Description: "Akums (A-02)_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3101010200",
    Description: "Akums (A-02)_Operations",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3401010200",
    Description: "A-02_Project_Ananta",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3501010200",
    Description: "Akums (A-02)_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3502010200",
    Description: "Akums (A-02)_QA_IPQA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3601010200",
    Description: "Akums (A-02)_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3701010200",
    Description: "Akums (A-02)_R&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3801010200",
    Description: "Akums (A-02)_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3802010200",
    Description: "Akums (A-02)_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3803010200",
    Description: "Akums (A-02)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3804010200",
    Description: "Akums (A-02)_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3805010200",
    Description: "Akums (A-02)_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3806010200",
    Description: "WH A-09 (Plant 2)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "3901010200",
    Description: "Akums (A-02)_SCM_PPIC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "4101010200",
    Description: "Akums (A-02)_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "5101010200",
    Description: "Akums (A-02)_Production",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "6001010200",
    Description: "Akums (A-02)_Dep_Ind-Lease Hold Land",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "6002010200",
    Description: "Akums (A-02)_Dep_Ind-Building",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "6003010200",
    Description: "Akums (A-02)_Dep_Ind-P & M",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "6004010200",
    Description: "Akums (A-02)_Dep_Ind-Elect.Instalat",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "6005010200",
    Description: "Akums (A-02)_Dep_Ind-Lab.equipments",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "6006010200",
    Description: "Akums (A-02)_Dep_Ind-F & F",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "6007010200",
    Description: "Akums (A-02)_Dep_Ind-Office Equipment",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0200",
    CostCenter: "6008010200",
    Description: "Akums (A-02)_Dep_Ind-Pol. Cont.Equ.",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "2101010235",
    Description: "Akums (A-02)_Adm_Admin_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "2301010235",
    Description: "Akums (A-02)_Comm._Purchase_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "2601010235",
    Description: "Akums (A-02)_ESG_ESG_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "2702010235",
    Description: "Akums (A-02)_Engg_Utility_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "2801010235",
    Description: "Akums (A-02)_Accounts_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "2904010235",
    Description: "Akums (A-02)_HR_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "3001010235",
    Description: "Akums (A-02)_IT_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "3101010235",
    Description: "Akums (A-02)_Operations_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "3501010235",
    Description: "Akums (A-02)_QA_QA_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "3601010235",
    Description: "Akums (A-02)_QC_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "3701010235",
    Description: "Akums (A-02)_R&D_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "3801010235",
    Description: "Akums (A-02)_Stores_RM_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "3802010235",
    Description: "Akums (A-02)_Stores_PM_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "3803010235",
    Description: "Akums (A-02)_Stores_SFG/WIP_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "3804010235",
    Description: "Akums (A-02)_Stores_FG_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "3805010235",
    Description: "Akums (A-02)_Stores_General_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0235",
    CostCenter: "5101010235",
    Description: "Akums (A-02)_Production_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2101010300",
    Description: "Akums (A-03)_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2103010300",
    Description: "Akums (A-03)_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2301010300",
    Description: "Akums (A-03)_Comm._Purchase",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2601010300",
    Description: "Akums (A-03)_ESG_ESG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2602010300",
    Description: "Akums (A-03)_ESG_EHS",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2701010300",
    Description: "Akums (A-03)_Engg_Maintenance",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2701020300",
    Description: "Akums (A-03)_Engg_Maint._E_Block",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2702010300",
    Description: "Akums (A-03)_Engg_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2702020300",
    Description: "Akums (A-03)_Engg_DG Set",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2702030300",
    Description: "Akums (A-03)_Engg_Boiler",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2904010300",
    Description: "Akums (A-03)_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "2904020300",
    Description: "Akums (A-03)_HR _ E Block",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3001010300",
    Description: "Akums (A-03)_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3101010300",
    Description: "Akums (A-03)_Operations",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3201010300",
    Description: "OE_A-03",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3501010300",
    Description: "Akums (A-03)_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3501020300",
    Description: "Akums (A-03)_QA_E Block",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3502010300",
    Description: "Akums (A-03)_QA_IPQA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3601010300",
    Description: "Akums (A-03)_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3602010300",
    Description: "Akums (A-03)_QC _ E Block",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3701010300",
    Description: "Akums (A-03)_R&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3801010300",
    Description: "Akums (A-03)_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3802010300",
    Description: "Akums (A-03)_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3803010300",
    Description: "Akums (A-03)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3804010300",
    Description: "Akums (A-03)_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3805010300",
    Description: "Akums (A-03)_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3806010300",
    Description: "WH A-09 (Plant 3)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3807010300",
    Description: "Akums (A-03)_Store_E_Block",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "3901010300",
    Description: "Akums (A-03)_SCM_PPIC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "4101010300",
    Description: "Akums (A-03)_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "5101010300",
    Description: "Akums (A-03)_Prod_Injection",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "5101020300",
    Description: "Akums (A-03)_Prod_Nasal Drop",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "5101030300",
    Description: "Akums (A-03)_Prod_3 Piece",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "6001010300",
    Description: "Akums (A-03)_Dep_Ind-Lease Hold Land",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "6002010300",
    Description: "Akums (A-03)_Dep_Ind-Building",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "6003010300",
    Description: "Akums (A-03)_Dep_Ind-P & M",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "6004010300",
    Description: "Akums (A-03)_Dep_Ind-Elect.Instalat",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "6005010300",
    Description: "Akums (A-03)_Dep_Ind-Lab.equipments",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "6006010300",
    Description: "Akums (A-03)_Dep_Ind-F & F",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "6007010300",
    Description: "Akums (A-03)_Dep_Ind-Office Equipment",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "6008010300",
    Description: "Akums (A-03)_Dep_Ind-Pol. Cont.Equ.",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "6009010300",
    Description: "Akums (A-03)_Dep_Ind-Vehicle",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0300",
    CostCenter: "6012010300",
    Description: "Akums (A-03)_Dep_Ind-Com.Software",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "2101010400",
    Description: "Akums (A-04)_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "2103010400",
    Description: "Akums (A-04)_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "2301010400",
    Description: "Akums (A-04)_Comm._Purchase",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "2601010400",
    Description: "Akums (A-04)_ESG_ESG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "2602010400",
    Description: "Akums (A-04)_ESG_EHS",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "2701010400",
    Description: "Akums (A-04)_Engg_Maintenance",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "2702010400",
    Description: "Akums (A-04)_Engg_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "2702020400",
    Description: "Akums (A-04)_Engg_DG Set",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "2702030400",
    Description: "Akums (A-04)_Engg_Boiler",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "2904010400",
    Description: "Akums (A-04)_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3001010400",
    Description: "Akums (A-04)_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3101010400",
    Description: "Akums (A-04)_Operations",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3201010400",
    Description: "OE_A-04",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3501010400",
    Description: "Akums (A-04)_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3502010400",
    Description: "Akums (A-04)_QA_IPQA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3601010400",
    Description: "Akums (A-04)_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3701010400",
    Description: "Akums (A-04)_R&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3801010400",
    Description: "Akums (A-04)_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3802010400",
    Description: "Akums (A-04)_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3803010400",
    Description: "Akums (A-04)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3804010400",
    Description: "Akums (A-04)_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3805010400",
    Description: "Akums (A-04)_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3806010400",
    Description: "WH A-09 (Plant 4)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "3901010400",
    Description: "Akums (A-04)_SCM_PPIC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "4101010400",
    Description: "Akums (A-04)_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "5101010400",
    Description: "Akums (A-04)_Production",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "6001010400",
    Description: "Akums (A-04)_Dep_Ind-Lease Hold Land",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "6002010400",
    Description: "Akums (A-04)_Dep_Ind-Building",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "6003010400",
    Description: "Akums (A-04)_Dep_Ind-P & M",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "6004010400",
    Description: "Akums (A-04)_Dep_Ind-Elect.Instalat",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "6005010400",
    Description: "Akums (A-04)_Dep_Ind-Lab.equipments",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "6006010400",
    Description: "Akums (A-04)_Dep_Ind-F & F",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "6007010400",
    Description: "Akums (A-04)_Dep_Ind-Office Equipment",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "6008010400",
    Description: "Akums (A-04)_Dep_Ind-Pol. Cont.Equ.",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "6009010400",
    Description: "Akums (A-04)_Dep_Ind-Vehicle",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0400",
    CostCenter: "6012010400",
    Description: "Akums (A-04)_Dep_Ind-Com.Software",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "2101010500",
    Description: "Akums (A-05)_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "2103010500",
    Description: "Akums (A-05)_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "2301010500",
    Description: "Akums (A-05)_Comm._Purchase",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "2601010500",
    Description: "Akums (A-05)_ESG_ESG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "2602010500",
    Description: "Akums (A-05)_ESG_EHS",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "2701010500",
    Description: "Akums (A-05)_Engg_Maintenance",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "2702010500",
    Description: "Akums (A-05)_Engg_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "2702020500",
    Description: "Akums (A-05)_Engg_DG Set",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "2702030500",
    Description: "Akums (A-05)_Engg_Boiler",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "2904010500",
    Description: "Akums (A-05)_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3001010500",
    Description: "Akums (A-05)_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3101010500",
    Description: "Akums (A-05)_Operations",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3501010500",
    Description: "Akums (A-05)_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3502010500",
    Description: "Akums (A-05)_QA_IPQA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3601010500",
    Description: "Akums (A-05)_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3701010500",
    Description: "Akums (A-05)_R&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3801010500",
    Description: "Akums (A-05)_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3802010500",
    Description: "Akums (A-05)_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3803010500",
    Description: "Akums (A-05)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3804010500",
    Description: "Akums (A-05)_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3805010500",
    Description: "Akums (A-05)_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3806010500",
    Description: "WH A-09 (Plant 5)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "3901010500",
    Description: "Akums (A-05)_SCM_PPIC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "4101010500",
    Description: "Akums (A-05)_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "5101010500",
    Description: "Akums (A-05)_Production",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "6003010500",
    Description: "Akums (A-05)_Dep_Ind-P & M",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0500",
    CostCenter: "6005010500",
    Description: "Akums (A-05)_Dep_Ind-Lab.equipments",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2101010700",
    Description: "Akums Hwr Corp_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2102010700",
    Description: "Akums Hwr Corp_Adm_Travel Management",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2103010700",
    Description: "Akums Hwr Corp_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2201010700",
    Description: "Akums Hwr Corp_Business Strategy",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2301010700",
    Description: "Akums Hwr Corp_Comm._Purchase",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2401010700",
    Description: "Akums Corp._Legal & Complaince",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2501010700",
    Description: "Akums Hwr Corp_DRA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2601010700",
    Description: "Akums Hwr Corp_ESG_ESG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2702010700",
    Description: "Akums Hwr Corp_Engg_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2801010700",
    Description: "Akums Hwr Corp_F&A_Accounts",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2802010700",
    Description: "Akums Hwr Corp_F&A_Costing & Budgeting",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2803010700",
    Description: "Akums Hwr Corp_F&A_Internal Audit",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2901010700",
    Description: "Akums Hwr Corp_HR_Payroll",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2903010700",
    Description: "Akums Hwr Corp_HR_Recruitment",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "2904010700",
    Description: "Akums Hwr Corp_HR_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "3001010700",
    Description: "Akums Hwr Corp_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "3101010700",
    Description: "Akums Hwr Corp_Operations",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "3201010700",
    Description: "Akums Hwr Corp_OE",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "3301010700",
    Description: "Akums Hwr Corp_P&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "3401010700",
    Description: "Akums Hwr Corp_Project",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "3501010700",
    Description: "Akums Hwr Corp_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "3601010700",
    Description: "Akums Hwr Corp_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "3805010700",
    Description: "Akums Hwr Corp_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "4101010700",
    Description: "Akums Hwr Corp_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "6010010700",
    Description: "Akums Hwr Corp_Dep_Ind-Land",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0700",
    CostCenter: "8001010700",
    Description: "Technical cell_Akums Corp",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "2101010710",
    Description: "Akums (A-09) Warehouse_Adm",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "2103010710",
    Description: "Akums (A-09) Warehouse_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "2501010710",
    Description: "Akums (A-09) Warehouse_DRA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "2602010710",
    Description: "EHS_Akums WH(A-09)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "2701010710",
    Description: "Maint_Akums WH(A-09)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "2904010710",
    Description: "HR_Akums WH(A-09)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "3001010710",
    Description: "IT_A-09 Warehouse Akums",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "3501010710",
    Description: "Akums (A-09) Warehouse_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "3601010710",
    Description: "Akums (A-09) Warehouse_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "3801010710",
    Description: "Akums (A-09) Warehouse_Stores_RM",
  },

  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "3802010710",
    Description: "Akums (A-09) Warehouse_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "3803010710",
    Description: "Akums (A-09) Warehouse_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "3804010710",
    Description: "Akums (A-09) Warehouse_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0710",
    CostCenter: "3805010710",
    Description: "Akums (A-09) Warehouse_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0800",
    CostCenter: "3601010800",
    Description: "Akums_QC R&D 1",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0800",
    CostCenter: "3701010800",
    Description: "Akums (A-01) R&D_R&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0800",
    CostCenter: "3801010800",
    Description: "Akums (A-01) R&D_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0800",
    CostCenter: "3802010800",
    Description: "Akums (A-01) R&D_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0800",
    CostCenter: "3803010800",
    Description: "Akums (A-01) R&D_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0800",
    CostCenter: "3804010800",
    Description: "Akums (A-01) R&D_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0800",
    CostCenter: "3805010800",
    Description: "Akums (A-01) R&D_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0810",
    CostCenter: "3601010810",
    Description: "Akums_QC R&D 2",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0810",
    CostCenter: "3701010810",
    Description: "R&D 2_R&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0810",
    CostCenter: "3801010810",
    Description: "R&D 2_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0810",
    CostCenter: "3802010810",
    Description: "R&D 2_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0810",
    CostCenter: "3803010810",
    Description: "R&D 2_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0810",
    CostCenter: "3804010810",
    Description: "R&D 2_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0810",
    CostCenter: "3805010810",
    Description: "R&D 2_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "2101010820",
    Description: "R&D_Mumbai_Adm",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "2702010820",
    Description: "R&D_Mumbai_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "2904010820",
    Description: "R&D_Mumbai_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "3001010820",
    Description: "R&D_Mumbai_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "3501010820",
    Description: "R&D_Mumbai_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "3601010820",
    Description: "R&D_Mumbai_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "3701010820",
    Description: "R&D_Mumbai_R&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "3801010820",
    Description: "R&D_Mumbai_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "3802010820",
    Description: "R&D_Mumbai_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "3803010820",
    Description: "R&D_Mumbai_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "3804010820",
    Description: "R&D_Mumbai_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "3805010820",
    Description: "R&D_Mumbai_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "6002010820",
    Description: "R&D_Mumbai_Dep_Ind-Building",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "6005010820",
    Description: "R&D_Mumbai_Dep_Ind-Lab.equipments",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "6006010820",
    Description: "R&D_Mumbai_Dep_Ind-F & F",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0820",
    CostCenter: "6007010820",
    Description: "R&D_Mumbai_Dep_Ind-Office Equipment",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0830",
    CostCenter: "3701010830",
    Description: "R&D Akums (A-04)_R&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0830",
    CostCenter: "3801010830",
    Description: "R&D Akums (A-04)_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0830",
    CostCenter: "3802010830",
    Description: "R&D Akums (A-04)_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0830",
    CostCenter: "3803010830",
    Description: "R&D Akums (A-04)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0830",
    CostCenter: "3804010830",
    Description: "R&D Akums (A-04)_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0830",
    CostCenter: "3805010830",
    Description: "R&D Akums (A-04)_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "2101010835",
    Description: "R&D_Mumbai_Adm_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "2301010835",
    Description: "R&D_Mumbai_Comm._Purchase_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "2702010835",
    Description: "R&D_Mumbai_Utility_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "2904010835",
    Description: "R&D_Mumbai_HR_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "3001010835",
    Description: "R&D_Mumbai_IT_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "3501010835",
    Description: "R&D_Mumbai_QA_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "3601010835",
    Description: "R&D_Mumbai_QC_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "3701010835",
    Description: "R&D_Mumbai_R&D_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "3801010835",
    Description: "R&D_Mumbai_Stores_RM_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "3802010835",
    Description: "R&D_Mumbai_Stores_PM_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "3803010835",
    Description: "R&D_Mumbai_Stores_SFG/WIP_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0835",
    CostCenter: "3804010835",
    Description: "R&D_Mumbai_Stores_FG_EU",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0840",
    CostCenter: "3001010840",
    Description: "IT_ R&D_4(Q)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0840",
    CostCenter: "3701010840",
    Description: "R&D 4_R&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0840",
    CostCenter: "3801010840",
    Description: "RM STORE_R&D 4",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0840",
    CostCenter: "3802010840",
    Description: "PM STORE_R&D 4",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0840",
    CostCenter: "3803010840",
    Description: "SFG/WIP_R&D 4",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0840",
    CostCenter: "3804010840",
    Description: "FG STORE_R&D 4",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0840",
    CostCenter: "3805010840",
    Description: "GEN. STORE_R&D 4",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "0900",
    CostCenter: "2101010900",
    Description: "Akums Vardhman site_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "2101011100",
    Description: "A-07 Akums (P&C LL)_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "2103011100",
    Description: "A-07 Akums (P&C LL)_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "2301011100",
    Description: "A-07 Akums (P&C LL)_Comm._Purchase",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "2702011100",
    Description: "A-07 Akums (P&C LL)_Engg_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "2904011100",
    Description: "A-07 Akums (P&C LL)_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "3001011100",
    Description: "A-07 Akums (P&C LL)_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "3501011100",
    Description: "A-07 Akums (P&C LL)_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "3502011100",
    Description: "A-07 Akums (P&C LL)_QA_IPQA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "3601011100",
    Description: "A-07 Akums (P&C LL)_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "3701011100",
    Description: "A-07 Akums (P&C LL)_R&D",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "3801011100",
    Description: "A-07 Akums (P&C LL)_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "3802011100",
    Description: "A-07 Akums (P&C LL)_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "3803011100",
    Description: "A-07 Akums (P&C LL)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "3804011100",
    Description: "A-07 Akums (P&C LL)_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "3805011100",
    Description: "A-07 Akums (P&C LL)_Stores_General",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "3901011100",
    Description: "A-07 Akums (P&C LL)_SCM_PPIC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "4101011100",
    Description: "A-07 Akums (P&C LL)_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "5101011100",
    Description: "A-07 Akums (P&C LL)_Prod_OSD_Granulation",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "5101021100",
    Description: "A-07 Akums (P&C LL)_Prod_OSD_Compression",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "5101031100",
    Description: "A-07 Akums (P&C LL)_Prod_OSD_Coating",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "5101041100",
    Description: "A-07 Akums (P&C LL)_Prod_OSD_Packing",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "5102011100",
    Description: "A-07 Akums (P&C LL)_Prod_Sterlie",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1100",
    CostCenter: "5103011100",
    Description: "A-07 Akums (P&C LL)_Prod_Ointment",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "2101011200",
    Description: "A-08 Akums (Malik Cepha LL)_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "2103011200",
    Description: "A-08 Akums (Malik Cepha LL)_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "2301011200",
    Description: "A-08 Akums(Malik Cepha LL)_Comm_Purchase",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "2702011200",
    Description: "A-08 Akums (Malik Cepha LL)_Engg_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "2904011200",
    Description: "A-08 Akums (Malik Cepha LL)_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "3001011200",
    Description: "A-08 Akums (Malik Cepha LL)_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "3501011200",
    Description: "A-08 Akums (Malik Cepha LL)_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "3502011200",
    Description: "A-08 Akums (Malik Cepha LL)_QA_IPQA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "3601011200",
    Description: "A-08 Akums (Malik Cepha LL)_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "3701011200",
    Description: "R&D_Malik_LL_Cepha_A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "3801011200",
    Description: "A-08 Akums (Malik Cepha LL)_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "3802011200",
    Description: "A-08 Akums (Malik Cepha LL)_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "3803011200",
    Description: "A-08 Akums(Malik CephaLL)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "3804011200",
    Description: "A-08 Akums (Malik Cepha LL)_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "3805011200",
    Description: "Gen.Store_Malik LL_Cepha_A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "3901011200",
    Description: "A-08 Akums (Malik Cepha LL)_SCM_PPIC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "4101011200",
    Description: "A-08 Akums (Malik Cepha LL)_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1200",
    CostCenter: "5101011200",
    Description: "Production_MalikLL Cepha A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "2101011210",
    Description: "A-08 Akums (Malik Penci. LL)_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "2103011210",
    Description: "A-08 Akums (Malik Penci.LL)_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "2301011210",
    Description: "A-08 Akums (Malik Penci LL)Comm_Purchase",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "2702011210",
    Description: "A-08 Akums (Malik Penci. L)_Eng_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "2904011210",
    Description: "A-08 Akums (Malik Penci. LL)_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "3001011210",
    Description: "A-08 Akums (Malik Penci. LL)_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "3501011210",
    Description: "A-08 Akums (Malik Penci. LL)_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "3502011210",
    Description: "A-08 Akums (Malik Penci. LL)_QA_IPQA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "3601011210",
    Description: "A-08 Akums (Malik Penci. LL)_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "3701011210",
    Description: "R&D_Malik_LL_Penc._A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "3801011210",
    Description: "A-08 Akums (Malik Penci. LL)_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "3802011210",
    Description: "A-08 Akums (Malik Penci. LL)_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "3803011210",
    Description: "A-08 Akums(Malik Penci LL)Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "3804011210",
    Description: "A-08 Akums (Malik Penci. LL)_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "3805011210",
    Description: "Gen.Store_Malik LL_Penc._A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "3901011210",
    Description: "A-08 Akums (Malik Penci. LL)_SCM_PPIC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "4101011210",
    Description: "A-08 Akums (Malik Penci. LL)_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1210",
    CostCenter: "5101011210",
    Description: "Production_MalikLL Penc.A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "2101011220",
    Description: "A-08 Akums (Malik Gen LL)_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "2103011220",
    Description: "A-08 Akums (Malik Gen LL)_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "2301011220",
    Description: "A-08 Akums (Malik Gen LL)_Comm._Purchase",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "2702011220",
    Description: "A-08 Akums (Malik Gen LL)_Engg_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "2904011220",
    Description: "A-08 Akums (Malik Gen LL)_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "3001011220",
    Description: "A-08 Akums (Malik Gen LL)_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "3501011220",
    Description: "A-08 Akums (Malik Gen LL)_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "3502011220",
    Description: "A-08 Akums (Malik Gen LL)_QA_IPQA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "3601011220",
    Description: "A-08 Akums (Malik Gen LL)_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "3701011220",
    Description: "R&D_Malik_LL_Gen._A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "3801011220",
    Description: "A-08 Akums (Malik Gen LL)_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "3802011220",
    Description: "A-08 Akums (Malik Gen LL)_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "3803011220",
    Description: "A-08 Akums (Malik Gen LL)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "3804011220",
    Description: "A-08 Akums (Malik Gen LL)_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "3805011220",
    Description: "Gen.Store_Malik LL_Gen._A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "3901011220",
    Description: "A-08 Akums (Malik Gen LL)_SCM_PPIC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "4101011220",
    Description: "A-08 Akums (Malik Gen LL)_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1220",
    CostCenter: "5101011220",
    Description: "Production_MalikLL Gen._A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "2101011230",
    Description: "A-08 Akums (Malik Unit4 LL)_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "2103011230",
    Description: "A-08 Akums (Malik Unit4 LL)_Adm_Security",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "2301011230",
    Description: "A-08 Akums(Malik Unit4 LL)_Comm_Purchase",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "2702011230",
    Description: "A-08 Akums (Malik Unit4 LL)_Engg_Utility",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "2904011230",
    Description: "A-08 Akums (Malik Unit4 LL)_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "3001011230",
    Description: "A-08 Akums (Malik Unit4 LL)_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "3501011230",
    Description: "A-08 Akums (Malik Unit4 LL)_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "3502011230",
    Description: "A-08 Akums (Malik Unit4 LL)_QA_IPQA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "3601011230",
    Description: "A-08 Akums (Malik Unit4 LL)_QC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "3701011230",
    Description: "R&D_Malik_LL_U-4_A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "3801011230",
    Description: "A-08 Akums (Malik Unit4 LL)_Stores_RM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "3802011230",
    Description: "A-08 Akums (Malik Unit4 LL)_Stores_PM",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "3803011230",
    Description: "A-08 Akums(Malik Unit4LL)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "3804011230",
    Description: "A-08 Akums (Malik Unit4 LL)_Stores_FG",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "3805011230",
    Description: "U-4.Store_Malik LL_U-4_A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "3901011230",
    Description: "A-08 Akums (Malik Unit4 LL)_SCM_PPIC",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "4101011230",
    Description: "A-08 Akums (Malik Unit4 LL)_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "1230",
    CostCenter: "5101011230",
    Description: "Production_MalikLL U-4_A-08",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "2101015000",
    Description: "Akums HO_Adm_Admin (Saraswati Vihar)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "2101025000",
    Description: "Akums HO_Adm_Admin (Mangolpuri)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "2301015000",
    Description: "Commercial_Akums HO",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "2401015000",
    Description: "Akums HO_Compliance_Legal",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "2801015000",
    Description: "Akums HO_F&A_Accounts",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "2904015000",
    Description: "Akums HO_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "3001015000",
    Description: "Akums HO_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "3501015000",
    Description: "Akums HO_QA_QA",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "4001015000",
    Description: "Akums HO_Secretariat_MD Secretariat",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "4002015000",
    Description: "Akums HO_Management",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "4003015000",
    Description: "Akums HO_Corporate Growth & Excellence",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "4101015000",
    Description: "Akums HO_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "4103015000",
    Description: "Akums HO_Business Development",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "4200015000",
    Description: "Akums HO_Process Improvement",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "4300015000",
    Description: "Akums HO_Portfolio Strategy",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "6006015000",
    Description: "Akums HO_Dep_Ind-F & F",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "6007015000",
    Description: "Akums HO_Dep_Ind-Office Equipment",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "6009015000",
    Description: "Akums HO_Dep_Ind-Vehicle",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "6011015000",
    Description: "Akums HO_Dep_Ind-Trade Mark",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5000",
    CostCenter: "6012015000",
    Description: "Akums HO_Dep_Ind-Com.Software",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5100",
    CostCenter: "2101015100",
    Description: "Akums Kundli_Adm_Admin",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5200",
    CostCenter: "2101015200",
    Description: "Akums_Admin (Noida office)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5300",
    CostCenter: "2101015300",
    Description: "Akums HO_ISD_Adm_Admin (Saraswati Vihar)",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5300",
    CostCenter: "2301015300",
    Description: "Akums HO_ISD_Commercial",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5300",
    CostCenter: "2401015300",
    Description: "Akums HO_ISD_Compliance_Legal",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5300",
    CostCenter: "2801015300",
    Description: "Akums HO_ISD_F&A_Accounts",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5300",
    CostCenter: "2904015300",
    Description: "Akums HO_ISD_HR",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5300",
    CostCenter: "3001015300",
    Description: "Akums HO_ISD_IT",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5300",
    CostCenter: "4001015300",
    Description: "Akums HO_ISD_Secretariat_MD Secretariat",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5300",
    CostCenter: "4002015300",
    Description: "Akums HO_ISD_Management",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5300",
    CostCenter: "4003015300",
    Description: "Akums HO_ISD_Corporate Growth & Excellen",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5300",
    CostCenter: "4101015300",
    Description: "Akums HO_ISD_S&M_Sales",
  },
  {
    CompanyCode: "1000",
    BusinessArea: "5300",
    CostCenter: "4103015300",
    Description: "Akums HO_ISD_Business Development",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "2101011600",
    Description: "AHL (A-10)_Adm_Admin",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "2103011600",
    Description: "AHL (A-10)_Adm_Security",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "2301011600",
    Description: "AHL (A-10)_Commercial_Purchase",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "2601011600",
    Description: "AHL (A-10)_ESG_EHS",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "2602011600",
    Description: "AHL (A-10)_ESG_ESG",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "2701011600",
    Description: "AHL (A-10)_Engg_Maintenance",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "2702011600",
    Description: "AHL (A-10)_Engg_Utility",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "2702021600",
    Description: "AHL (A-10)_Engg_DG Set",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "2702031600",
    Description: "AHL (A-10)_Engg_Boiler",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "2801011600",
    Description: "AHL Corp._F&A_Accounts",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "2904051600",
    Description: "AHL (A-10)_HR_Human Resource",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3001011600",
    Description: "AHL (A-10)_IT_IT",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3101011600",
    Description: "AHL (A-10)_Operations_Operations",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3501011600",
    Description: "AHL (A-10)_QA_QA",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3502011600",
    Description: "AHL (A-10)_QA_IPQA",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3601011600",
    Description: "AHL (A-10)_QC_QC",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3701011600",
    Description: "AHL (A-10)_R&D_R&D",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3801011600",
    Description: "AHL (A-10)_Stores_Raw Material",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3802011600",
    Description: "AHL (A-10)_Stores_Packing Material",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3803011600",
    Description: "AHL (A-10)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3804011600",
    Description: "AHL (A-10)_Stores_Finished Goods",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3805011600",
    Description: "AHL (A-10)_Stores_General Stores",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3806011600",
    Description: "WH A-09 (AHL-1)",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "3901011600",
    Description: "AHL (A-10)_SCM_PPIC",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "4101011600",
    Description: "AHL (A-10)_Sales_S&M",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "5101011600",
    Description: "AHL (A-10)_Prod_Sterile",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "5101021600",
    Description: "AHL (A-10)_Prod_Oral Liquid",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1600",
    CostCenter: "5101031600",
    Description: "AHL (A-10)_Prod_OSD",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "2101011610",
    Description: "AHL (A-12)_Adm_Admin",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "2103011610",
    Description: "AHL (A-12)_Adm_Security",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "2301011610",
    Description: "AHL (A-12)_Commercial_Purchase",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "2601011610",
    Description: "AHL (A-12)_ESG_EHS",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "2602011610",
    Description: "AHL (A-12)_ESG_ESG",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "2701011610",
    Description: "AHL (A-12)_Engg_Maintenance",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "2702011610",
    Description: "AHL (A-12)_Engg_Utility",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "2702021610",
    Description: "AHL (A-12)_Engg_DG Set",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "2702031610",
    Description: "AHL (A-12)_Engg_Boiler",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "2904051610",
    Description: "AHL (A-12)_HR_Human Resource",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3001011610",
    Description: "AHL (A-12)_IT_IT",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3101011610",
    Description: "AHL (A-12)_Operations_Operations",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3501011610",
    Description: "AHL (A-12)_QA_QA",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3502011610",
    Description: "AHL (A-12)_QA_IPQA",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3601011610",
    Description: "AHL (A-12)_QC_QC",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3701011610",
    Description: "AHL (A-12)_R&D_R&D",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3801011610",
    Description: "AHL (A-12)_Stores_Raw Material",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3802011610",
    Description: "AHL (A-12)_Stores_Packing Material",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3803011610",
    Description: "AHL (A-12)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3804011610",
    Description: "AHL (A-12)_Stores_Finished Goods",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3805011610",
    Description: "AHL (A-12)_Stores_General Stores",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3806011610",
    Description: "WH A-09 (AHL-2)",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "3901011610",
    Description: "AHL (A-12)_SCM_PPIC",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "4101011610",
    Description: "AHL (A-12)_Sales_S&M",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1610",
    CostCenter: "5101011610",
    Description: "AHL (A-12)_Production",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "2101011620",
    Description: "AHL (A-09)_Adm_Admin",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "2103011620",
    Description: "AHL (A-09)_Adm_Security",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "2301011620",
    Description: "AHL (A-09)_Commercial_Purchase",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "2601011620",
    Description: "AHL (A-09)_ESG_EHS",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "2602011620",
    Description: "AHL (A-09)_ESG_ESG",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "2701011620",
    Description: "AHL (A-09)_Engg_Maintenance",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "2702011620",
    Description: "AHL (A-09)_Engg_Utility",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "2702021620",
    Description: "AHL (A-09)_Engg_DG Set",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "2702031620",
    Description: "AHL (A-09)_Engg_Boiler",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "2904051620",
    Description: "AHL (A-09)_HR_Human Resource",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3001011620",
    Description: "AHL (A-09)_IT_IT",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3101011620",
    Description: "AHL (A-09)_Operations_Operations",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3501011620",
    Description: "AHL (A-09)_QA_QA",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3502011620",
    Description: "AHL (A-09)_QA_IPQA",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3601011620",
    Description: "AHL (A-09)_QC_QC",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3701011620",
    Description: "AHL (A-09)_R&D_R&D",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3801011620",
    Description: "AHL (A-09)_Stores_Raw Material",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3802011620",
    Description: "AHL (A-09)_Stores_Packing Material",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3803011620",
    Description: "AHL (A-09)_Stores_SFG/WIP",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3804011620",
    Description: "AHL (A-09)_Stores_Finished Goods",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3805011620",
    Description: "AHL (A-09)_Stores_General Stores",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3806011620",
    Description: "WH A-09 (AHL-3)",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "3901011620",
    Description: "AHL (A-09)_SCM_PPIC",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "4101011620",
    Description: "AHL (A-09)_Sales _S&M",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1620",
    CostCenter: "5101011620",
    Description: "AHL (A-09)_Prod_Corrugated Boxes",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2101011670",
    Description: "AHL Corp._Adm_Admin",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2102011670",
    Description: "AHL Corp._Adm_Travel Management",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2103011670",
    Description: "AHL Corp._Adm_Security",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2201011670",
    Description: "AHL Corp._Bus. Planning_Strategy/Assur.",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2202011670",
    Description: "AHL Corp._Bus. Planning_Bus. Dev.",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2301011670",
    Description: "AHL Corp._Commercial_Purchase",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2401011670",
    Description: "AHL Corp._Compliance_Legal & Complaince",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2501011670",
    Description: "AHL Corp._DRA_DRA",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2601011670",
    Description: "AHL Corp._ESG_EHS",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2602011670",
    Description: "AHL Corp._ESG_ESG",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2701011670",
    Description: "AHL Corp._Engg_Maintenance",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2702011670",
    Description: "AHL Corp._Engg_Utility",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2801011670",
    Description: "AHL Corp._F&A_Accounts",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "2904051670",
    Description: "AHL Corp._HR_Human Resource",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "3001011670",
    Description: "AHL Corp._IT_IT",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "3101011670",
    Description: "AHL Corp._Operations_Operations",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "3201011670",
    Description: "AHL Corp._OE_Operational Excellence",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "3301011670",
    Description: "AHL Corp._P&D_Packaging & Development",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "3401011670",
    Description: "AHL Corp._Project_Project",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "3701011670",
    Description: "AHL Corp._R&D_R&D",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "3805011670",
    Description: "AHL Corp._Stores_General Stores",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "3901011670",
    Description: "AHL Corp._SCM_PPIC",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "4001011670",
    Description: "AHL Corp._Secretariat_MD Secretariat",
  },
  {
    CompanyCode: "1600",
    BusinessArea: "1670",
    CostCenter: "4101011670",
    Description: "AHL Corp._Sales_S&M",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4050",
    CostCenter: "2801014050",
    Description: "Qualymed_Delhi_HO_F&A_Accounts",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4050",
    CostCenter: "2904054050",
    Description: "Qualymed_Delhi_HO_HR",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4050",
    CostCenter: "3001014050",
    Description: "Qualymed_Delhi_HO_IT",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4100",
    CostCenter: "2702014100",
    Description: "Qualymed_HWR_Engg_Utility",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4100",
    CostCenter: "2801014100",
    Description: "Qualymed_HWR_F&A_Accounts",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4100",
    CostCenter: "2904014100",
    Description: "Qualymed_HWR_HR",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4100",
    CostCenter: "3001014100",
    Description: "Akums_HWR_IT",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4100",
    CostCenter: "3601014100",
    Description: "Qualymed_HWR_QC",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4100",
    CostCenter: "3805014100",
    Description: "Akums_HWR_Stores_General",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4100",
    CostCenter: "5101014100",
    Description: "Qualymed_HWR_Prod",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4200",
    CostCenter: "2702014200",
    Description: "Qualymed_Jammu-1_(A-15)_Engg_Utility",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4200",
    CostCenter: "2801014200",
    Description: "Qualymed_Jammu-1_F&A_Accounts",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4200",
    CostCenter: "2904014200",
    Description: "Qualymed_Jammu-1_(A-15)_HR",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4200",
    CostCenter: "3001014200",
    Description: "Akums_Jammu-1_(A-15)_IT",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4200",
    CostCenter: "3601014200",
    Description: "Qualymed_Jammu-1_(A-15)_QC",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4200",
    CostCenter: "3805014200",
    Description: "Akums_Jammu-1_(A-15)_Stores_General",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4200",
    CostCenter: "5101014200",
    Description: "Qualymed_Jammu-1_(A-15)Prod",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4300",
    CostCenter: "2702014300",
    Description: "Qualymed_Jammu-2_(A-16)_Engg_Utility",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4300",
    CostCenter: "2801014300",
    Description: "Qualymed_Jammu-2_F&A_Accounts",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4300",
    CostCenter: "2904014300",
    Description: "Qualymed_Jammu-2_(A-16)_HR",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4300",
    CostCenter: "3001014300",
    Description: "Akums_Jammu-2_(A-16)_IT",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4300",
    CostCenter: "3601014300",
    Description: "Qualymed_Jammu-2_(A-16)_QC",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4300",
    CostCenter: "3805014300",
    Description: "Akums_Jammu-2_(A-16)_Stores_General",
  },
  {
    CompanyCode: "4000",
    BusinessArea: "4300",
    CostCenter: "5101014300",
    Description: "Qualymed_Jammu-2_(A-16)Prod",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "2101019000",
    Description: "Maxcure_Adm_Adm",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "2103019000",
    Description: "Maxcure_Adm_Security",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "2301019000",
    Description: "Maxcure_Commercial_Purchase",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "2601019000",
    Description: "Maxcure_EHS_HMS",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "2602019000",
    Description: "Maxcure_EHS_Environment",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "2701019000",
    Description: "Maxcure_Engg_Maintenance",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "2702019000",
    Description: "Maxcure_Engg_Utility",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "2702029000",
    Description: "Maxcure_Engg_DG Set",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "2702039000",
    Description: "Maxcure_Engg_Boiler",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "2801019000",
    Description: "Maxcure_F&A_Accounts",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "2904059000",
    Description: "Maxcure_HR_HR",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3001019000",
    Description: "Maxcure_IT_IT",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3101019000",
    Description: "Maxcure_Operations_Operations",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3401019000",
    Description: "Project",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3501019000",
    Description: "Maxcure_QA_QA",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3502019000",
    Description: "Maxcure_QA_QMS",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3503019000",
    Description: "Maxcure_QA_IPQA",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3504019000",
    Description: "Maxcure_QA_Compliance/Validation",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3505019000",
    Description: "Maxcure_QA_Documentation",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3506019000",
    Description: "Maxcure_QA_Terminal",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3601019000",
    Description: "Maxcure_QC_QC",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3701019000",
    Description: "Maxcure_R&D_R&D",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3801019000",
    Description: "Maxcure_Stores_Raw Material",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3802019000",
    Description: "Maxcure_Stores_Packing Material",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3803019000",
    Description: "Maxcure_Stores_SFG/WIP",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3804019000",
    Description: "Maxcure_Stores_Finished Goods",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3805019000",
    Description: "Maxcure_Stores_General Stores",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3806019000",
    Description: "WH A-09 (Maxcure)",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3901019000",
    Description: "Maxcure_SCM_PPIC",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "3902019000",
    Description: "Max_SupplyChain_SCM",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "4101019000",
    Description: "Maxcure_S & M_Sales",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "5101019000",
    Description: "Maxcure_Prod_Oral",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "5101029000",
    Description: "Maxcure_Prod_Oral Packing",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "5102019000",
    Description: "Maxcure_Prod_ENO",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "5103019000",
    Description: "Maxcure_Prod_Gummies",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9000",
    CostCenter: "5104019000",
    Description: "Maxcure_Prod_Liquid",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9010",
    CostCenter: "2101019010",
    Description: "Maxcure_Admin",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9010",
    CostCenter: "3701019010",
    Description: "R&D_Maxcure(9010)",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9010",
    CostCenter: "3801019010",
    Description: "RM STORE_R&D Maxcure",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9010",
    CostCenter: "3802019010",
    Description: "PM STORE_R&D Maxcure",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9010",
    CostCenter: "3803019010",
    Description: "SFG/WIP_R&D Maxcure",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9010",
    CostCenter: "3804019010",
    Description: "FG STORE_R&D Maxcure",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9020",
    CostCenter: "2101019020",
    Description: "Maxcure Narela_Adm_Adm",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "2101019050",
    Description: "Maxcure HO_Admin)",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "2401019050",
    Description: "Maxcure HO_Secreterial & Legal",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "2801019050",
    Description: "Maxcure HO_F&A_Accounts",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "2804019050",
    Description: "MAX DELHI HO_WCDL",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "2904059050",
    Description: "Maxcure HO_HR_HR",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "3001019050",
    Description: "Maxcure HO_IT_IT",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "3902019050",
    Description: "Maxcure_HO_SCM",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "4001019050",
    Description: "Maxcure HO_Secretariat_MD Secretariat",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "4002019050",
    Description: "Max HO_Management",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "4003019050",
    Description: "Maxcure HO_Corporate Growth & Excellence",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "4101019050",
    Description: "Maxcure HO_S & M_Sales",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "4102019050",
    Description: "Maxcure HO_S & M_Marketing",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "4103019050",
    Description: "Maxcure HO_Business Development",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "4200019050",
    Description: "Maxcure HO_Process Improvement",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9050",
    CostCenter: "4300019050",
    Description: "Maxcure HO_Portfolio Strategy",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9060",
    CostCenter: "2101019060",
    Description: "Maxcure HO_ISD_Admin)",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9060",
    CostCenter: "2401019060",
    Description: "Maxcure HO_ISD_Secreterial & Legal",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9060",
    CostCenter: "2801019060",
    Description: "Maxcure HO_ISD_F&A",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9060",
    CostCenter: "2804019060",
    Description: "MAX DELHI HO_ISD_WCDL",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9060",
    CostCenter: "2904059060",
    Description: "Maxcure HO_ISD_HR",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9060",
    CostCenter: "3001019060",
    Description: "Maxcure HO_ISD_IT",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9060",
    CostCenter: "3902019060",
    Description: "Maxcure HO_ISD_SCM",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9060",
    CostCenter: "4001019060",
    Description: "Maxcure HO_ISD_Secretariat",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9060",
    CostCenter: "4002019060",
    Description: "Max HO_ISD_Management",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9060",
    CostCenter: "4003019060",
    Description: "Maxcure HO_ISD_Corporate Growth & Excell",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9060",
    CostCenter: "4101019060",
    Description: "Maxcure HO_ISD_S & M",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2101019070",
    Description: "Maxcure_Corp._Adm",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2102019070",
    Description: "Maxcure_Corp._Travel Mgmt",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2103019070",
    Description: "Maxcure_Corp._Security",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2201019070",
    Description: "Maxcure_Corp._Strategy/Assurance",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2301019070",
    Description: "Maxcure_Purchase_Corp",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2401019070",
    Description: "Maxcure_Corp._Legal",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2501019070",
    Description: "Maxcure_Corp._DRA",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2601019070",
    Description: "Maxcure_Corp._HMS",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2602019070",
    Description: "Maxcure_Corp._Environment",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2701019070",
    Description: "Maxcure_Corp._Maintenance",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2702019070",
    Description: "Maxcure_Corp._Utility",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2801019070",
    Description: "Maxcure_Corp._Accounts",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2802019070",
    Description: "Maxcure_Corp._Costing & Budgeting",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2803019070",
    Description: "Maxcure_Corp._Internal Audit",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2901019070",
    Description: "Maxcure_Corp._Payroll",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2902019070",
    Description: "Maxcure_Corp._Time Management",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2903019070",
    Description: "Maxcure_Corp._Recruitment",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "2904059070",
    Description: "Maxcure_Corp._HR",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "3001019070",
    Description: "Maxcure_Corp._IT",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "3101019070",
    Description: "Maxcure_Corp._Operations",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "3201019070",
    Description: "Maxcure_Corp._OE",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "3301019070",
    Description: "Maxcure_Corp._Packing & Development",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "3401019070",
    Description: "Maxcure_Corp._Project",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "3501019070",
    Description: "Maxcure_Corp._QA",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "3601019070",
    Description: "Maxcure_Corp._QC",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "3701019070",
    Description: "Maxcure_Corp._R&D",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "3805019070",
    Description: "Maxcure_Corp._General Stores",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "3901019070",
    Description: "Maxcure_Corp._PPIC",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "3902019070",
    Description: "Maxcure_Corp._SCM",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "4001019070",
    Description: "Maxcure_Corp._MD Secretariat",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9070",
    CostCenter: "4401019070",
    Description: "Estate_Maxcure Corp",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9200",
    CostCenter: "2101019200",
    Description: "Maxcure Trading_Adm_Adm",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9200",
    CostCenter: "2701019200",
    Description: "Maxcure Trading_Engg_Maintenance",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9200",
    CostCenter: "2801019200",
    Description: "Maxcure Trading_F&A_Accounts",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9200",
    CostCenter: "2804019200",
    Description: "Maxcure Trading_F&A_WCDL",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9200",
    CostCenter: "3801019200",
    Description: "Maxcure Trading_Stores_Raw Material",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9200",
    CostCenter: "3802019200",
    Description: "Maxcure Trading_Stores_Packing Material",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9200",
    CostCenter: "3803019200",
    Description: "Maxcure Trading_Stores_SFG/WIP",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9200",
    CostCenter: "3804019200",
    Description: "Maxcure Trading_Stores_Finished Goods",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9200",
    CostCenter: "3805019200",
    Description: "Maxcure Trading_Stores_General Stores",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9200",
    CostCenter: "3901019200",
    Description: "Maxcure Trading_SCM_PPIC",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9200",
    CostCenter: "4101019200",
    Description: "Maxcure Trading_S & M_Sales",
  },
  {
    CompanyCode: "9000",
    BusinessArea: "9300",
    CostCenter: "4101019300",
    Description: "Maxcure_S & M_Sales",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2101019400",
    Description: "Malik_Adm_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2103019400",
    Description: "Malik_Security_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2301019400",
    Description: "Malik_Purchase_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2601019400",
    Description: "Malik_HMS_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2602019400",
    Description: "Malik_Environment _Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2701019400",
    Description: "Malik_Maintenance_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2702019400",
    Description: "Malik_Utility_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2702029400",
    Description: "Malik_Engg_DG Set_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2702039400",
    Description: "Malik_Engg_Boiler_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2801019400",
    Description: "Malik_Accounts",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2804019400",
    Description: "Malik_WCDL_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "2904019400",
    Description: "Malik_Human Resource_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3001019400",
    Description: "Malik_IT_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3101019400",
    Description: "Malik_Operations_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3401019400",
    Description: "Malik_Project_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3501019400",
    Description: "Malik_QA_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3503019400",
    Description: "Malik_IPQA_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3601019400",
    Description: "Malik_QC_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3602019400",
    Description: "Malik_Micro_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3701019400",
    Description: "Malik_R&D_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3801019400",
    Description: "Malik_Raw Material _Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3802019400",
    Description: "Malik_Packing Material_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3803019400",
    Description: "Malik_SFG/WIP_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3804019400",
    Description: "Malik_Finished Goods_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3805019400",
    Description: "Malik_General Stores_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3806019400",
    Description: "WH A-09 (Malik)",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3901019400",
    Description: "SCM_Malik_PPIC_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "3902019400",
    Description: "Malik_SupplyChain_SCM",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "4101019400",
    Description: "Malik_Sales _Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "5101019400",
    Description: "Malik_Prod_Unit 1 (Cepha.)_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "5102019400",
    Description: "C&D_Prod_Malik",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "6001019400",
    Description: "Malik_Ind-Lease Hold Land_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "6002019400",
    Description: "Malik_Ind-Building_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "6003019400",
    Description: "Malik_Ind-P & M_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "6004019400",
    Description: "Malik_Ind-Elect.Instalat_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "6005019400",
    Description: "Malik_Ind-Lab.Equ_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "6006019400",
    Description: "Malik_Ind-F & F_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "6007019400",
    Description: "Malik_Ind-Off.Equ_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9400",
    CostCenter: "6008019400",
    Description: "Malik_Ind-Pol. Cont.Equ._Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "2101019410",
    Description: "Malik_Adm_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "2103019410",
    Description: "Malik_Security_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "2301019410",
    Description: "Malik_Purchase_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "2601019410",
    Description: "Malik_HMS_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "2602019410",
    Description: "Malik_Environment _Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "2701019410",
    Description: "Malik_Maintenance_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "2702019410",
    Description: "Malik_Utility_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "2904019410",
    Description: "Malik_Human Resource_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3001019410",
    Description: "Malik_IT_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3101019410",
    Description: "Malik_Operations_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3501019410",
    Description: "Malik_QA_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3503019410",
    Description: "Malik_IPQA_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3601019410",
    Description: "Malik_QC_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3602019410",
    Description: "Malik_Micro_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3701019410",
    Description: "Malik_R&D_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3801019410",
    Description: "Malik_Raw Material _Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3802019410",
    Description: "Malik_Packing Material_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3803019410",
    Description: "Malik_SFG/WIP_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3804019410",
    Description: "Malik_Finished Goods_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3805019410",
    Description: "Malik_General Stores_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3901019410",
    Description: "SCM_Malik_PPIC_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "3902019410",
    Description: "Malik_SupplyChain_SCM",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "4101019410",
    Description: "Malik_Sales_Penicillin",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "5101019410",
    Description: "Malik_Prod_Unit 1 (Cepha.)_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9410",
    CostCenter: "5102019410",
    Description: "Malik_Prod_Unit 2 (Penicilin.)",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "2101019420",
    Description: "Malik_Adm_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "2103019420",
    Description: "Malik_Security_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "2301019420",
    Description: "Malik_Purchase_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "2601019420",
    Description: "Malik_HMS_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "2602019420",
    Description: "Malik_Environment _General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "2701019420",
    Description: "Malik_Maintenance_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "2702019420",
    Description: "Malik_Utility_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "2904019420",
    Description: "Malik_Human Resource_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3001019420",
    Description: "Malik_IT_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3101019420",
    Description: "Malik_Operations_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3501019420",
    Description: "Malik_QA_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3503019420",
    Description: "Malik_IPQA_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3601019420",
    Description: "Malik_QC_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3602019420",
    Description: "Malik_Micro_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3701019420",
    Description: "Malik_R&D_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3801019420",
    Description: "Malik_Raw Material _General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3802019420",
    Description: "Malik_Packing Material_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3803019420",
    Description: "Malik_SFG/WIP_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3804019420",
    Description: "Malik_Finished Goods_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3805019420",
    Description: "Malik_General Stores_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3901019420",
    Description: "SCM_Malik_PPIC_General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "3902019420",
    Description: "Malik_SupplyChain_SCM",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "4101019420",
    Description: "Malik_Sales _General",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "5101019420",
    Description: "Malik_Prod_Unit 1 (Cepha.)_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9420",
    CostCenter: "5103019420",
    Description: "Malik_Prod_Unit 3 (General)_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "2101019430",
    Description: "Malik_Adm_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "2103019430",
    Description: "Malik_Security_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "2301019430",
    Description: "Malik_Purchase_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "2601019430",
    Description: "Malik_HMS_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "2602019430",
    Description: "Malik_Environment _Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "2701019430",
    Description: "Malik_Maintenance_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "2702019430",
    Description: "Malik_Utility_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "2904019430",
    Description: "Malik_Human Resource_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3001019430",
    Description: "Malik_IT_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3101019430",
    Description: "Malik_Operations_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3501019430",
    Description: "Malik_QA_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3503019430",
    Description: "Malik_IPQA_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3601019430",
    Description: "Malik_QC_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3602019430",
    Description: "Malik_Micro_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3701019430",
    Description: "Malik_R&D_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3801019430",
    Description: "Malik_Raw Material _Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3802019430",
    Description: "Malik_Packing Material_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3803019430",
    Description: "Malik_SFG/WIP_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3804019430",
    Description: "Malik_Finished Goods_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3805019430",
    Description: "Malik_General Stores_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "3901019430",
    Description: "SCM_Malik_PPIC_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "4101019430",
    Description: "Malik_Sales _Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "5101019430",
    Description: "Malik_Prod_Unit 1 (Cepha.)_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9430",
    CostCenter: "5104019430",
    Description: "Malik_Prod_Unit 4",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9440",
    CostCenter: "2101019440",
    Description: "Malik_Adm_Cepha",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9440",
    CostCenter: "3601019440",
    Description: "Malik_QC_Unit 5",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "2101019450",
    Description: "Malik HO_Adm",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "2101029450",
    Description: "Malik HO_Adm_Admin (Mangolpuri)",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "2101029450",
    Description: "Malik HO_Adm_Admin (Mangolpuri)",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "2301019450",
    Description: "Commercial_malik HO",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "2401019450",
    Description: "Malik HO_Secreterial & Legal",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "2801019450",
    Description: "Malik HO_Accounts",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "2804019450",
    Description: "Malik HO_WCDL",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "2904019450",
    Description: "Malik HO_HR",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "3001019450",
    Description: "Malik HO_IT",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "3805019450",
    Description: "Malik HO_General Stores",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "4001019450",
    Description: "Malik HO_Secretariat_MD Secretariat",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "4002019450",
    Description: "Malik HO_Management",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "4003019450",
    Description: "Malik HO_Corporate Growth & Excellence",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "4102019450",
    Description: "Malik HO_Sales & Marketing",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "4103019450",
    Description: "Malik HO_Business Development",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "4200019450",
    Description: "Malik HO_Process Improvement",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9450",
    CostCenter: "4300019450",
    Description: "Malik HO_Process Improvement",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9460",
    CostCenter: "2101019460",
    Description: "Malik HO_ISD_Adm",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9460",
    CostCenter: "2301019460",
    Description: "Malik HO_ISD_Commercial",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9460",
    CostCenter: "2401019460",
    Description: "Malik HO_ISD_Secreterial & Legal",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9460",
    CostCenter: "2801019460",
    Description: "Malik HO_ISD_Accounts",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9460",
    CostCenter: "2804019460",
    Description: "Malik HO_ISD_WCDL",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9460",
    CostCenter: "2904019460",
    Description: "Malik HO_ISD_HR",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9460",
    CostCenter: "3001019460",
    Description: "Malik HO_ISD_IT",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9460",
    CostCenter: "3805019460",
    Description: "Malik HO_ISD_General Stores",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9460",
    CostCenter: "4001019460",
    Description: "Malik HO_ISD_Secretariat_MD Secretariat",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9460",
    CostCenter: "4003019460",
    Description: "Malik HO_ISD_Corporate Growth & Excellen",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9460",
    CostCenter: "4102019460",
    Description: "Malik HO_ISD_Sales & Marketing",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "2101019470",
    Description: "Malik_Adm_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "2301019470",
    Description: "Malik_Purchase_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "2401019470",
    Description: "Malik_Legal & Complaince_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "2601019470",
    Description: "Malik_HMS_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "2701019470",
    Description: "Malik_Maintenance_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "2702019470",
    Description: "Malik_Utility_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "2801019470",
    Description: "Malik_Accounts_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "2803019470",
    Description: "Malik_Internal Audit_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "2904019470",
    Description: "Malik_HR_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "3001019470",
    Description: "Malik_IT_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "3401019470",
    Description: "Project_Malik_Corp.",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "3501019470",
    Description: "Malik_QA",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "3601019470",
    Description: "Malik_QC_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "3805019470",
    Description: "Malik_General Stores_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "3901019470",
    Description: "Malik_PPIC_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "4001019470",
    Description: "Malik_MD Secretariat_",
  },
  {
    CompanyCode: "9400",
    BusinessArea: "9470",
    CostCenter: "8001019470",
    Description: "Technical cell_Malik Corp",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2101019700",
    Description: "P&C (A-07)Adm_Admin",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2103019700",
    Description: "P&C (A-07)Adm_Security",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2201019700",
    Description: "Strategy assurance_P&C HWR",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2301019700",
    Description: "P&C (A-07)Commercial_Purchase",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2501019700",
    Description: "P&C (A-07)DRA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2601019700",
    Description: "P&C (A-07)EHS_HMS",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2602019700",
    Description: "P&C (A-07)EHS_Environment",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2701019700",
    Description: "P&C (A-07)Engg_Maintenance_Unit 1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2701029700",
    Description: "P&C (A-07)Engg_Maintenance_Unit 2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2701039700",
    Description: "P&C (A-07)Engg_Maintenance_Unit 3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2701049700",
    Description: "P&C (A-07)Engg_Maintenance_Unit 4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2701059700",
    Description: "P&C (A-07)Engg_Maintenance",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2702019700",
    Description: "P&C (A-07)Engg_Utility_Unit 1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2702029700",
    Description: "P&C (A-07)Engg_Utility_Unit 2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2702039700",
    Description: "P&C (A-07)Engg_Utility_Unit 3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2702049700",
    Description: "P&C (A-07)Engg_Utility_Unit 4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2702059700",
    Description: "P&C (A-07)Engg_Utility",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2801019700",
    Description: "P&C (A-07)F&A_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2802019700",
    Description: "Costing_P&C Hwr",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2803019700",
    Description: "P&C (A-07)F&A_Internal Audit",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2804019700",
    Description: "P&C (A-07)_WCDL",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2805019700",
    Description: "P&C (A-07)_Term Loan",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2904019700",
    Description: "P&C (A-07)HR_Human Resource_Unit 1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2904029700",
    Description: "P&C (A-07)HR_Human Resource_Unit 2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2904039700",
    Description: "P&C (A-07)HR_Human Resource_Unit 3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2904049700",
    Description: "P&C (A-07)HR_Human Resource_Unit 4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "2904059700",
    Description: "P&C (A-07)HR_Human Resource",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3001019700",
    Description: "P&C (A-07)IT_IT",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3101019700",
    Description: "P&C (A-07)Operations_Operations",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3201019700",
    Description: "P&C (A-07)OE_OE",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3401019700",
    Description: "P&C (A-07)Project_Project",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3501019700",
    Description: "P&C (A-07)QA_QA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3501029700",
    Description: "P&C (A-07)_CQA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3502019700",
    Description: "P&C (A-07)QA_QMS_Unit 1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3502029700",
    Description: "P&C (A-07)QA_QMS_Unit 2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3502039700",
    Description: "P&C (A-07)QA_QMS_Unit 3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3502049700",
    Description: "P&C (A-07)QA_QMS_Unit 4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3503019700",
    Description: "P&C (A-07)QA_IPQA_Unit 1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3503029700",
    Description: "P&C (A-07)QA_IPQA_Unit 2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3503039700",
    Description: "P&C (A-07)QA_IPQA_Unit 3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3503049700",
    Description: "P&C (A-07)QA_IPQA_Unit 4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3504019700",
    Description: "P&C (A-07)QA_Compliance/Validation_U-1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3504029700",
    Description: "P&C (A-07)QA_Compliance/Validation_U-2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3504039700",
    Description: "P&C (A-07)QA_Compliance/Validation_U-3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3504049700",
    Description: "P&C (A-07)QA_Compliance/Validation_U-4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3505019700",
    Description: "P&C (A-07)QA_Documentation_Unit 1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3505029700",
    Description: "P&C (A-07)QA_Documentation_Unit 2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3505039700",
    Description: "P&C (A-07)QA_Documentation_Unit 3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3505049700",
    Description: "P&C (A-07)QA_Documentation_Unit 4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3506019700",
    Description: "P&C (A-07)QA_Terminal_Unit 1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3506029700",
    Description: "P&C (A-07)QA_Terminal_Unit 2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3506039700",
    Description: "P&C (A-07)QA_Terminal_Unit 3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3506049700",
    Description: "P&C (A-07)QA_Terminal_Unit 4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3601019700",
    Description: "P&C (A-07)QC_QC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3701019700",
    Description: "P&C (A-07)R&D_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3702019700",
    Description: "P&C (A-07)F&D_F&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3703019700",
    Description: "P&C (A-07)_Technology Transfer",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3801019700",
    Description: "P&C (A-07)Stores_Raw Material_Unit 1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3801029700",
    Description: "P&C (A-07)Stores_Raw Material_Unit 2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3801039700",
    Description: "P&C (A-07)Stores_Raw Material_Unit 3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3801049700",
    Description: "P&C (A-07)Stores_Raw Material_Unit 4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3801059700",
    Description: "P&C (A-07)Stores_Raw Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3802019700",
    Description: "P&C (A-07)Stores_Packing Material_Unit 1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3802029700",
    Description: "P&C (A-07)Stores_Packing Material_Unit 2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3802039700",
    Description: "P&C (A-07)Stores_Packing Material_Unit 3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3802049700",
    Description: "P&C (A-07)Stores_Packing Material_Unit 4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3802059700",
    Description: "P&C (A-07)Stores_Packing Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3803019700",
    Description: "P&C (A-07)Stores_SFG/WIP_Unit 1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3803029700",
    Description: "P&C (A-07)Stores_SFG/WIP_Unit 2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3803039700",
    Description: "P&C (A-07)Stores_SFG/WIP_Unit 3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3803049700",
    Description: "P&C (A-07)Stores_SFG/WIP_Unit 4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3803059700",
    Description: "P&C (A-07)Stores_SFG/WIP",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3804019700",
    Description: "P&C (A-07)Stores_Finished Goods",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3805019700",
    Description: "P&C (A-07)Stores_General Stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3806019700",
    Description: "WH A-09 (P&C H)",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "3901019700",
    Description: "P&C (A-07)SCM_PPIC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "4001019700",
    Description: "P&C (A-07)Technical Secretariat",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "4002019700",
    Description: "P&C (A-07)MD Office",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "4101019700",
    Description: "P&C (A-07)S&M_Sales",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "4401019700",
    Description: "Estate_P&C_A-07",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "5101019700",
    Description: "P&C (A-07)Prod_Unit 1 (OSD)_G Block",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "5101029700",
    Description: "P&C (A-07)Prod_Unit 1 (OSD)_F Block",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "5101039700",
    Description: "P&C (A-07)Prod_Unit 1 (OSD)_H Block",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "5101049700",
    Description: "P&C (A-07)Prod_Unit 1 (OSD)_H1 Block",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "5102019700",
    Description: "P&C (A-07)Prod_Unit 2 (Sterile)_I Block",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "5102029700",
    Description: "P&C (A-07)Prod_Unit 2 (Sterile)_Q Block",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "5103019700",
    Description: "P&C (A-07)Prod_Unit 3_Q Block Oint/Liqui",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "5104019700",
    Description: "P&C (A-07)Prod_Unit 4_L Block",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "6001019700",
    Description: "P&C (A-07)Other_Dep_Ind-Lease Hold Land",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "6002019700",
    Description: "P&C (A-07)Other_Dep_Ind-Building",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "6003019700",
    Description: "P&C (A-07)Other_Dep_Ind-P & M",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "6004019700",
    Description: "P&C (A-07)Other_Dep_Ind-Elect.Instalat",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "6005019700",
    Description: "P&C (A-07)Other_Dep_Ind-Lab.Equ",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "6006019700",
    Description: "P&C (A-07)Other_Dep_Ind-F & F",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "6007019700",
    Description: "P&C (A-07)Other_Dep_Ind-Off.Equ",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "6008019700",
    Description: "P&C (A-07)Other_Dep_Ind-Pol. Cont.Equ.",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "6009019700",
    Description: "P&C (A-07)Other_Dep_Ind-Vehicle",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9700",
    CostCenter: "8001019700",
    Description: "Technical cell_P&C",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9703",
    CostCenter: "2702059703",
    Description: "P&C Warehouse_Engg_Utility",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9703",
    CostCenter: "3801059703",
    Description: "P&C Warehouse_Stores_Raw Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9703",
    CostCenter: "3802059703",
    Description: "P&C Warehouse_Stores_Packing Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9703",
    CostCenter: "3803059703",
    Description: "P&C Warehouse_Stores_SFG/WIP",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9703",
    CostCenter: "3804019703",
    Description: "P&C Warehouse_Stores_Finished Goods",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9703",
    CostCenter: "3805019703",
    Description: "P&C Warehouse_Stores_General Stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9703",
    CostCenter: "5104019703",
    Description: "P&C Warehouse_Prod_Unit 4 (L Block)",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9709",
    CostCenter: "2801019709",
    Description: "Accounts_Plant 1 LL",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9709",
    CostCenter: "3801059709",
    Description: "P&C Plant 1 LL_Stores_Raw Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9709",
    CostCenter: "3802059709",
    Description: "P&C Plant 1 LL_Stores_Packing Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9709",
    CostCenter: "3803059709",
    Description: "P&C Plant 1 LL_Stores_SFG/WIP",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9709",
    CostCenter: "3804019709",
    Description: "P&C Plant 1 LL_Stores_Finished Goods",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9709",
    CostCenter: "3805019709",
    Description: "P&C Plant 1 LL_Stores_General Stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9709",
    CostCenter: "5101019709",
    Description: "P&C Plant 1 LL_Production",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9711",
    CostCenter: "2801019711",
    Description: "P&C - AKUMS-2(LL) F&A_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9711",
    CostCenter: "3801059711",
    Description: "P&C Plant 2 LL_Stores_Raw Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9711",
    CostCenter: "3802059711",
    Description: "P&C Plant 2 LL_Stores_Packing Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9711",
    CostCenter: "3803059711",
    Description: "P&C Plant 2 LL_Stores_SFG/WIP",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9711",
    CostCenter: "3804019711",
    Description: "P&C Plant 2 LL_Stores_Finished Goods",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9711",
    CostCenter: "3805019711",
    Description: "P&C Plant 2 LL_Stores_General Stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9711",
    CostCenter: "5101019711",
    Description: "P&C Plant 2 LL_Prod_Liquid oral",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9720",
    CostCenter: "2801019720",
    Description: "P&C (R&D)F&A_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9720",
    CostCenter: "3601019720",
    Description: "P&C _R&D_QC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9720",
    CostCenter: "3701019720",
    Description: "P&C_R&D Drug_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9720",
    CostCenter: "3702019720",
    Description: "P&C_F&D Drug_F&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9720",
    CostCenter: "3801059720",
    Description: "P&C_R&D Drug_Raw Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9720",
    CostCenter: "3802059720",
    Description: "P&C_R&D Drug_Packing Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9720",
    CostCenter: "3803059720",
    Description: "P&C_R&D Drug_SFG/WIP",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9720",
    CostCenter: "3804019720",
    Description: "P&C_R&D Drug_Finished Goods",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9720",
    CostCenter: "3805019720",
    Description: "P&C_R&D Drug_General Stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9721",
    CostCenter: "2801019721",
    Description: "P&C (R&D)F&A_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9721",
    CostCenter: "3701019721",
    Description: "P&C_R&D Nutra_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9721",
    CostCenter: "3702019721",
    Description: "P&C_F&D Nutra_F&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9721",
    CostCenter: "3801059721",
    Description: "P&C_R&D Nutra_Raw Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9721",
    CostCenter: "3802059721",
    Description: "P&C_R&D Nutra_Packing Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9721",
    CostCenter: "3803059721",
    Description: "P&C_R&D Nutra_SFG/WIP",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9721",
    CostCenter: "3804019721",
    Description: "P&C_R&D Nutra_Finished Goods",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9721",
    CostCenter: "3805019721",
    Description: "P&C_R&D Nutra_General Stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "2101019730",
    Description: "P&C (A-11)ADM_ADM",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "2103019730",
    Description: "P&C (A-11)_ADM_Security",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "2301019730",
    Description: "P&C (A-11)Commercial_Purchase",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "2601019730",
    Description: "P&C (A-11)EHS_HMS",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "2701019730",
    Description: "P&C (A-11)Engg_Maint.",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "2702019730",
    Description: "P&C (A-11)Engg_Utility",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "2703019730",
    Description: "P&C (A-11)Engg_DG Set",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "2704019730",
    Description: "P&C (A-11)Engg_Boiler",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "2705019730",
    Description: "P&C (A-11)Engg_ETP",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "2801019730",
    Description: "P&C (A-11)F&A_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "2904019730",
    Description: "P&C (A-11)HR",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3001019730",
    Description: "P&C (A-11)IT",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3101019730",
    Description: "P&C (A-11)Operations_Operations",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3401019730",
    Description: "P&C (A-11)Project_Project",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3501019730",
    Description: "P&C (A-11)QA_QA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3601019730",
    Description: "P&C (A-11)QC_QC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3701019730",
    Description: "P&C (A-11)R&D_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3801019730",
    Description: "P&C (A-11)Stores_Raw Material_G1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3801029730",
    Description: "P&C (A-11)Stores_Raw Material_G2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3802019730",
    Description: "P&C (A-11)Stores_Packing  Material_G1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3802029730",
    Description: "P&C (A-11)Stores_Packing  Material_G2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3803019730",
    Description: "P&C (A-11)Stores_SFG/WIP_G1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3803029730",
    Description: "P&C (A-11)Stores_SFG/WIP_G2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3804019730",
    Description: "P&C (A-11)Stores_FG",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3805019730",
    Description: "P&C (A-11)Stores_General stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "3901019730",
    Description: "P&C (A-11)SCM_PPIC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "4101019730",
    Description: "P&C (A-11)S&M_Sales",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "5101019730",
    Description: "P&C (A-11)Prod_OSD_G1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "5102019730",
    Description: "P&C (A-11)Prod_Liquids_G2",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "5103019730",
    Description: "P&C (A-11)Prod__G3",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9730",
    CostCenter: "5104019730",
    Description: "P&C (A-11)Prod__G4",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9731",
    CostCenter: "3701019731",
    Description: "P&C (A-11)R&D_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9731",
    CostCenter: "3801019731",
    Description: "P&C (A-11)Stores_Raw Material_G1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9731",
    CostCenter: "3802019731",
    Description: "P&C (A-11)Stores_Packing  Material_G1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9731",
    CostCenter: "3803019731",
    Description: "P&C (A-11)Stores_SFG/WIP_G1",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9731",
    CostCenter: "3804019731",
    Description: "P&C (A-11)Stores_FG",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9731",
    CostCenter: "3805019731",
    Description: "P&C (A-11)Stores_General stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "2101019735",
    Description: "P&C (A-11)ADM_ADM_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "2301019735",
    Description: "P&C (A-11)Commercial_Purchase_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "2702019735",
    Description: "P&C (A-11)Engg_Utility_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "2801019735",
    Description: "P&C (A-11)F&A_Accounts_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "2904019735",
    Description: "P&C (A-11)HR_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "3001019735",
    Description: "P&C (A-11)IT_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "3101019735",
    Description: "P&C (A-11)Operations_Operations_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "3401019735",
    Description: "P&C (A-11)Project_Project_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "3501019735",
    Description: "P&C (A-11)QA_QA_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "3601019735",
    Description: "P&C (A-11)QC_QC_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "3701019735",
    Description: "P&C (A-11)R&D_R&D_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "3801019735",
    Description: "P&C (A-11)Stores_Raw Material_G1_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "3802019735",
    Description: "P&C (A-11)Stores_PackingÂ  Material_G1_E",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "3803029735",
    Description: "P&C (A-11)Stores_SFG/WIP_G2_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "3804019735",
    Description: "P&C (A-11)Stores_FG_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9735",
    CostCenter: "3805019735",
    Description: "P&C (A-11)Stores_General stores_EU",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "2101019740",
    Description: "P&C (A-13)ADM_ADM",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "2103019740",
    Description: "P&C (A-13)ADM_Security",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "2301019740",
    Description: "P&C (A-13)Commercial_Purchase",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "2401019740",
    Description: "P&C (A-13)LegalCompliance",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "2601019740",
    Description: "P&C (A-13)EHS_HMS",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "2701019740",
    Description: "P&C (A-13)Engg_Maint.",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "2702019740",
    Description: "P&C (A-13)Engg_Utility",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "2801019740",
    Description: "P&C (A-13)F&A_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "2904019740",
    Description: "P&C (A-13)HR_HR",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3001019740",
    Description: "P&C (A-13)IT_IT",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3101019740",
    Description: "P&C (A-13)Operations_Operations",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3401019740",
    Description: "P&C (A-13)Project_Project",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3501019740",
    Description: "P&C (A-13)QA_QA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3601019740",
    Description: "P&C (A-13)QC_QC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3701019740",
    Description: "P&C (A-13)R&D_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3801019740",
    Description: "P&C (A-13)Stores_Raw Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3802019740",
    Description: "P&C (A-13)Stores_Packing  Material",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3803019740",
    Description: "P&C (A-13)Stores_SFG/WIP",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3804019740",
    Description: "P&C (A-13)Stores_FG",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3805019740",
    Description: "P&C (A-13)Stores_General stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "3901019740",
    Description: "P&C (A-13)SCM_PPIC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "4101019740",
    Description: "P&C (A-13)S&M_Sales",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9740",
    CostCenter: "5101019740",
    Description: "P&C (A-13)Prod_Prod",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "2101019750",
    Description: "P&C_HO_Adm",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "2202019750",
    Description: "P&C_HO_Bus. Planning",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "2401019750",
    Description: "P&C_HO_Secreterial & Legal",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "2701059750",
    Description: "P&C_HO_Maintenance",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "2801019750",
    Description: "P&C_HO_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "2904059750",
    Description: "P&C_HO_HR",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "3001019750",
    Description: "P&C_HO_IT",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "3701019750",
    Description: "P&C_HO_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "3805019750",
    Description: "P&C_HO_General Stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "3901019750",
    Description: "P&C_HO_PPIC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "3902019750",
    Description: "P&C_HO_SCM",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "4001019750",
    Description: "P&C_HO_MD Secretariat",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "4002019750",
    Description: "P&C HO_Management",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "4003019750",
    Description: "P&C HO_Corporate Growth & Excellence",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "4101019750",
    Description: "P&C_HO_Sales",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "4102019750",
    Description: "P&C_HO_Marketing",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "4103019750",
    Description: "P&C HO_Business Development",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "4200019750",
    Description: "P&C HO_Process Improvement",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9750",
    CostCenter: "4300019750",
    Description: "P&C HO_Portfolio Strategy",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "2101019760",
    Description: "P&C HO_ISD_Adm",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "2401019760",
    Description: "P&C HO_ISD_Secreterial & Legal",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "2701059760",
    Description: "P&C HO_ISD_Maintenance",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "2801019760",
    Description: "P&C HO_ISD_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "2904059760",
    Description: "P&C HO_ISD_HR",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "3001019760",
    Description: "P&C HO_ISD_IT",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "3701019760",
    Description: "P&C HO_ISD_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "3805019760",
    Description: "P&C HO_ISD_General Stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "3901019760",
    Description: "P&C HO_ISD_PPIC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "4001019760",
    Description: "P&C HO_ISD_MD Secretariat",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "4101019760",
    Description: "P&C HO_ISD_Sales",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "4102019760",
    Description: "P&C HO_ISD_Marketing",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9760",
    CostCenter: "4103019760",
    Description: "P&C HO_ISD_Business Development",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2101019770",
    Description: "P&C Hwr Corp._Adm_Adm",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2102019770",
    Description: "P&C Hwr Corp._Adm_Travel Management",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2103019770",
    Description: "P&C Hwr Corp._Adm_Security",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2201019770",
    Description: "P&C Hwr Corp._Bus.Plann._Strategy/Assur.",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2301019770",
    Description: "P&C Hwr Corp._Commercial_Purchase",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2401019770",
    Description: "P&C Hwr Corp._Compliance_Legal",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2501019770",
    Description: "P&C Hwr Corp._DRA_DRA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2601019770",
    Description: "P&C Hwr Corp._EHS_Health & Safety (HMS)",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2602019770",
    Description: "P&C Hwr Corp._EHS_Environment",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2701059770",
    Description: "P&C Hwr Corp._Engg_Maintenance",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2702059770",
    Description: "P&C Hwr Corp._Engg_Utility",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2801019770",
    Description: "P&C Hwr Corp._F&A_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2802019770",
    Description: "P&C Hwr Corp._F&A_Costing & Budgeting",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2803019770",
    Description: "P&C Hwr Corp._F&A_Internal Audit",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2901019770",
    Description: "P&C Hwr Corp._HR_Payroll",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2902019770",
    Description: "P&C Hwr Corp._HR_Time Management",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2903019770",
    Description: "P&C Hwr Corp._HR_Recruitment",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "2904059770",
    Description: "P&C Hwr Corp._HR_HR",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "3001019770",
    Description: "P&C Hwr Corp._IT_IT",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "3101019770",
    Description: "P&C Hwr Corp._Operations_Operations",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "3201019770",
    Description: "P&C Hwr Corp._OE_OE",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "3301019770",
    Description: "P&C Hwr Corp._P&D_Packing & Development",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "3401019770",
    Description: "P&C Hwr Corp._Project_Project",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "3501019770",
    Description: "P&C Hwr Corp._QA_QA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "3601019770",
    Description: "P&C Hwr Corp._QC_QC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "3701019770",
    Description: "P&C Hwr Corp._R&D_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "3805019770",
    Description: "P&C Hwr Corp._Stores_General Stores",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "3901019770",
    Description: "P&C Hwr Corp._SCM_PPIC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "3902019770",
    Description: "P&C Hwr Corp._SCM_SCM",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "4001019770",
    Description: "P&C Hwr Corp._Secretariat_MD Secret.",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "4401019770",
    Description: "Estate_P&C Corp.",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "8001019770",
    Description: "Technical cell_ Corp_P&C",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9770",
    CostCenter: "8002019770",
    Description: "Pharmacovigilance",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "2101019780",
    Description: "ALS CORP_Adm_Adm",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "2301019780",
    Description: "ALS CORP_Commercial_Purchase",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "2401019780",
    Description: "ALS CORP_Compliance_Legal",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "2501019780",
    Description: "ALS CORP_DRA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "2601019780",
    Description: "ALS CORP_EHS_HMS",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "2602019780",
    Description: "ALS CORP_EHS_Environment",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "2701019780",
    Description: "ALS CORP_Engg_Maintenance",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "2702019780",
    Description: "ALS CORP_Engg_Utility",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "2801019780",
    Description: "ALS CORP_F&A_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "2803019780",
    Description: "ALS CORP_Internal Audit",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "2904019780",
    Description: "ALS CORP_HR_HR",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "3001019780",
    Description: "ALS CORP_IT_IT",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "3101019780",
    Description: "ALS CORP_Operations_Operations",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "3801019780",
    Description: "ALS CORP_Stores_Warehouse",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "4001019780",
    Description: "ALS CORP_Secretariat_MD Secretariat",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9780",
    CostCenter: "4101019780",
    Description: "ALS CORP_S&M_Sales",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2101019781",
    Description: "ALS 1_Adm_Adm",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2103019781",
    Description: "ALS 1_Adm_Security",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2301019781",
    Description: "ALS 1_Commercial_Purchase",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2401019781",
    Description: "ALS 1_Compliance_Legal",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2501019781",
    Description: "ALS 1_DRA_DRA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2601019781",
    Description: "ALS 1_EHS_HMS",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2602019781",
    Description: "ALS 1_EHS_Environment",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2701019781",
    Description: "ALS 1_Engg_Maintenance",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2702019781",
    Description: "ALS 1_Engg_Utility",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2703019781",
    Description: "ALS 1_Engg_Hvac",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2704019781",
    Description: "ALS 1_Engg_Boiler",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2705019781",
    Description: "ALS 1_Engg_DG Set",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2706019781",
    Description: "ALS 1_Engg_Chiller",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2707019781",
    Description: "ALS 1_Engg_Compressor",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2801019781",
    Description: "ALS 1_F&A_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "2904019781",
    Description: "ALS 1_HR_HR",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "3001019781",
    Description: "ALS 1_IT_IT",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "3101019781",
    Description: "ALS 1_Operations_Operations",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "3201019781",
    Description: "ALS-1._OE",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "3501019781",
    Description: "ALS 1_QA_QA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "3601019781",
    Description: "ALS 1_QC_QC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "3701019781",
    Description: "ALS 1_R&D_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "3801019781",
    Description: "ALS 1_Stores_Warehouse",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "3901019781",
    Description: "ALS 1_SCM_PPIC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "3902019781",
    Description: "ALS 1_SCM_SCM",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "4101019781",
    Description: "ALS 1_S&M_Sales",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "5101019781",
    Description: "ALS 1_Prod_BLOCK-K (SRP)",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "5101029781",
    Description: "ALS 1_Prod_BLOCK-G",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "5101039781",
    Description: "ALS 1_Prod_BLOCK-E",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "5101049781",
    Description: "ALS 1_Prod_BLOCK-I",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "5101059781",
    Description: "ALS 1_Prod_BLOCK-D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "5101069781",
    Description: "ALS 1_Prod_BLOCK-J",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "5101079781",
    Description: "ALS 1_Prod_BLOCK-H",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9781",
    CostCenter: "7001019781",
    Description: "ALS 1_Common",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2101019782",
    Description: "ALS 2_Adm_Adm",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2103019782",
    Description: "ALS 2_Adm_Security",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2301019782",
    Description: "ALS 2_Commercial_Purchase",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2401019782",
    Description: "ALS 2_Compliance_Legal",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2501019782",
    Description: "ALS 2_DRA_DRA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2601019782",
    Description: "ALS 2_EHS_HMS",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2602019782",
    Description: "ALS 2_EHS_Environment",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2701019782",
    Description: "ALS 2_Engg_Maintenance",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2702019782",
    Description: "ALS 2_Engg_Utility",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2703019782",
    Description: "ALS 2_Engg_Hvac",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2704019782",
    Description: "ALS 2_Engg_Boiler",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2705019782",
    Description: "ALS 2_Engg_DG Set",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2706019782",
    Description: "ALS 2_Engg_Chiller",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2707019782",
    Description: "ALS 2_Engg_Compressor",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2801019782",
    Description: "ALS 2_F&A_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "2904019782",
    Description: "ALS 2_HR_HR",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "3001019782",
    Description: "ALS 2_IT_IT",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "3101019782",
    Description: "ALS 2_Operations_Operations",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "3201019782",
    Description: "ALS-2._OE",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "3501019782",
    Description: "ALS 2_QA_QA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "3601019782",
    Description: "ALS 2_QC_QC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "3701019782",
    Description: "ALS 2_R&D_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "3801019782",
    Description: "ALS 2_Stores_Warehouse",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "3901019782",
    Description: "ALS 2_SCM_PPIC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "3902019782",
    Description: "ALS 2_SCM_SCM",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "4101019782",
    Description: "ALS 2_S&M_Sales",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "5101019782",
    Description: "ALS 2_Prod_BLOCK-B",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "5101029782",
    Description: "ALS 2_Prod_BLOCK-C",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "5101039782",
    Description: "ALS 2_Prod_BLOCK-D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "5101049782",
    Description: "ALS 2_Prod_BLOCK-S (SRP)",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "5101059782",
    Description: "ALS 2_Prod_Kilo-Lab",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "5101069782",
    Description: "ALS 2_Prod_BLOCK-R",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9782",
    CostCenter: "7001019782",
    Description: "ALS 2_Common",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2101019783",
    Description: "ALS 3_Adm_Adm",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2103019783",
    Description: "ALS 3_Adm_Security",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2301019783",
    Description: "ALS 3_Commercial_Purchase",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2401019783",
    Description: "ALS 3_Compliance_Legal",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2501019783",
    Description: "ALS 3_DRA_DRA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2601019783",
    Description: "ALS 3_EHS_HMS",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2602019783",
    Description: "ALS 3_EHS_Environment",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2701019783",
    Description: "ALS 3_Engg_Maintenance",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2702019783",
    Description: "ALS 3_Engg_Utility",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2703019783",
    Description: "ALS 3_Engg_Hvac",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2704019783",
    Description: "ALS 3_Engg_Boiler",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2705019783",
    Description: "ALS 3_Engg_DG Set",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2706019783",
    Description: "ALS 3_Engg_Chiller",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2707019783",
    Description: "ALS 3_Engg_Compressor",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2801019783",
    Description: "ALS 3_F&A_Accounts",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "2904019783",
    Description: "ALS 3_HR_HR",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "3001019783",
    Description: "ALS 3_IT_IT",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "3101019783",
    Description: "ALS 3_Operations_Operations",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "3501019783",
    Description: "ALS 3_QA_QA",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "3601019783",
    Description: "ALS 3_QC_QC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "3701019783",
    Description: "ALS 3_R&D_R&D",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "3801019783",
    Description: "ALS 3_Stores_Warehouse",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "3901019783",
    Description: "ALS 3_SCM_PPIC",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "3902019783",
    Description: "ALS 3_SCM_SCM",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "4101019783",
    Description: "ALS 3_S&M_Sales",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "5101019783",
    Description: "ALS 3_Prod_Production (9783)",
  },
  {
    CompanyCode: "9700",
    BusinessArea: "9783",
    CostCenter: "7001019783",
    Description: "ALS 3_Common",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "2101019900",
    Description: "Upadhrish_Adm_Admin",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "2103019900",
    Description: "Upadhrish_Adm_Security",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "2301019900",
    Description: "Upadhrish_Comm._Purchase",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "2601019900",
    Description: "Upadhrish_ESG_ESG",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "2602019900",
    Description: "Upadrish_ESG_EHS",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "2701019900",
    Description: "Upadhrish_Engg_Maintenance",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "2702019900",
    Description: "Upadhrish_Engg_Utility",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "2702029900",
    Description: "Upadhrish_Engg_DG Set",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "2702039900",
    Description: "Upadhrish_Engg_Boiler",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "2904019900",
    Description: "Upadhrish__HR",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3001019900",
    Description: "Upadhrish__IT",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3101019900",
    Description: "Upadhrish__Operations",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3201019900",
    Description: "Upadhrish_OE",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3501019900",
    Description: "Upadhrish_QA_QA",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3601019900",
    Description: "Upadhrish__QC",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3701019900",
    Description: "Upadhrish_R&D",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3801019900",
    Description: "Upadhrish_Stores_RM",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3802019900",
    Description: "Upadhrish_Stores_PM",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3803019900",
    Description: "Upadhrish_Stores_SFG/WIP",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3804019900",
    Description: "Upadhrish_Stores_FG",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3805019900",
    Description: "Upadhrish_Stores_General",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "3901019900",
    Description: "Upadhrish_SCM_PPIC",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "4101019900",
    Description: "Upadhrish_S&M_Sales",
  },
  {
    CompanyCode: "9900",
    BusinessArea: "9900",
    CostCenter: "5101019900",
    Description: "Upadhrish_Production",
  },
];

export const departmentsOptions = [
  { label: "Department", value: "Department" },
  { label: "ADMIN", value: "ADMIN" },
  { label: "CLRNG", value: "CLRNG" },
  { label: "COMM", value: "COMM" },
  { label: "CONSL", value: "CONSL" },
  { label: "DIRCO", value: "DIRCO" },
  { label: "ENL", value: "ENL" },
  { label: "EXPIY", value: "EXPIY" },
  { label: "FINAN", value: "FINAN" },
  { label: "HR", value: "HR" },
  { label: "IT", value: "IT" },
  { label: "LEGAL", value: "LEGAL" },
  { label: "LOGIS", value: "LOGIS" },
  { label: "MKTG", value: "MKTG" },
  { label: "OFFRO", value: "OFFRO" },
  { label: "RA", value: "RA" },
  { label: "TENDR", value: "TENDR" },
  { label: "TENPE", value: "TENPE" },
  { label: "TRAVL", value: "TRAVL" },
];

export const regionsOptions = [
  { label: "Bukrs-Emerging", value: "Bukrs-Emerging" },
  { label: "DIRC", value: "DIRC" },
  { label: "EAU", value: "EAU" },
  { label: "EBL", value: "EBL" },
  { label: "EMN", value: "EMN" },
  { label: "EMX", value: "EMX" },
  { label: "ENL", value: "ENL" },
  { label: "EPC", value: "EPC" },
  { label: "EPE", value: "EPE" },
  { label: "EPP", value: "EPP" },
  { label: "ESA", value: "ESA" },
  { label: "LPK", value: "LPK" },
];

export const tillomedList = [
  { label: "Tillomed", value: "Tillomed" },
  {
    label: "Corporate-ACCOUNTS & FINANCE-TIM000_001",
    value: "Corporate-ACCOUNTS & FINANCE-TIM000_001",
  },
  {
    label: "Corporate-BUSINESS DEVELOPMENT-TIM000_002",
    value: "Corporate-BUSINESS DEVELOPMENT-TIM000_002",
  },
  {
    label: "Corporate-CORPORATE-TIM000_003",
    value: "Corporate-CORPORATE-TIM000_003",
  },
  {
    label: "Corporate-HR/ADMIN-TIM000_004",
    value: "Corporate-HR/ADMIN-TIM000_004",
  },
  {
    label: "Corporate-INFORMATION SYSTEMS-TIM000_005",
    value: "Corporate-INFORMATION SYSTEMS-TIM000_005",
  },
  { label: "Corporate-LEGAL-TIM000_006", value: "Corporate-LEGAL-TIM000_006" },
  { label: "Corporate-QA/QC-TIM000_007", value: "Corporate-QA/QC-TIM000_007" },
  {
    label: "Corporate-REGULATORY-TIM000_008",
    value: "Corporate-REGULATORY-TIM000_008",
  },
  {
    label: "Corporate-SALES & MARKETING-TIM000_009",
    value: "Corporate-SALES & MARKETING-TIM000_009",
  },
  {
    label: "Corporate-SOURCING-TIM000_010",
    value: "Corporate-SOURCING-TIM000_010",
  },
  {
    label: "Corporate-WAREHOUSE-TIM000_011",
    value: "Corporate-WAREHOUSE-TIM000_011",
  },
  {
    label: "Distribution/Exports-ACCOUNTS & FINANCE-TIM001_001",
    value: "Distribution/Exports-ACCOUNTS & FINANCE-TIM001_001",
  },
  {
    label: "Distribution/Exports-BUSINESS DEVELOPMENT-TIM001_002",
    value: "Distribution/Exports-BUSINESS DEVELOPMENT-TIM001_002",
  },
  {
    label: "Distribution/Exports-CORPORATE-TIM001_003",
    value: "Distribution/Exports-CORPORATE-TIM001_003",
  },
  {
    label: "Distribution/Exports-HR/ADMIN-TIM001_004",
    value: "Distribution/Exports-HR/ADMIN-TIM001_004",
  },
  {
    label: "Distribution/Exports-INFORMATION SYSTEMS-TIM001_005",
    value: "Distribution/Exports-INFORMATION SYSTEMS-TIM001_005",
  },
  {
    label: "Distribution/Exports-LEGAL-TIM001_006",
    value: "Distribution/Exports-LEGAL-TIM001_006",
  },
  {
    label: "Distribution/Exports-QA/QC-TIM001_007",
    value: "Distribution/Exports-QA/QC-TIM001_007",
  },
  {
    label: "Distribution/Exports-REGULATORY-TIM001_008",
    value: "Distribution/Exports-REGULATORY-TIM001_008",
  },
  {
    label: "Distribution/Exports-SALES & MARKETING-TIM001_009",
    value: "Distribution/Exports-SALES & MARKETING-TIM001_009",
  },
  {
    label: "Distribution/Exports-SOURCING-TIM001_010",
    value: "Distribution/Exports-SOURCING-TIM001_010",
  },
  {
    label: "Distribution/Exports-WAREHOUSE-TIM001_011",
    value: "Distribution/Exports-WAREHOUSE-TIM001_011",
  },
  {
    label: "Germany-ACCOUNTS & FINANCE-TIM002_001",
    value: "Germany-ACCOUNTS & FINANCE-TIM002_001",
  },
  {
    label: "Germany-BUSINESS DEVELOPMENT-TIM002_002",
    value: "Germany-BUSINESS DEVELOPMENT-TIM002_002",
  },
  {
    label: "Germany-CORPORATE-TIM002_003",
    value: "Germany-CORPORATE-TIM002_003",
  },
  {
    label: "Germany-HR/ADMIN-TIM002_004",
    value: "Germany-HR/ADMIN-TIM002_004",
  },
  {
    label: "Germany-INFORMATION SYSTEMS-TIM002_005",
    value: "Germany-INFORMATION SYSTEMS-TIM002_005",
  },
  { label: "Germany-LEGAL-TIM002_006", value: "Germany-LEGAL-TIM002_006" },
  { label: "Germany-QA/QC-TIM002_007", value: "Germany-QA/QC-TIM002_007" },
  {
    label: "Germany-REGULATORY-TIM002_008",
    value: "Germany-REGULATORY-TIM002_008",
  },
  {
    label: "Germany-SOURCING-TIM002_010",
    value: "Germany-SOURCING-TIM002_010",
  },
  {
    label: "Germany-WAREHOUSE-TIM002_011",
    value: "Germany-WAREHOUSE-TIM002_011",
  },
  {
    label: "Corporate-ACCOUNTS & FINANCE-TIL000_001",
    value: "Corporate-ACCOUNTS & FINANCE-TIL000_001",
  },
  {
    label: "Corporate-CORPORATE-TIL000_003",
    value: "Corporate-CORPORATE-TIL000_003",
  },
  {
    label: "Corporate-HR/ADMIN-TIL000_004",
    value: "Corporate-HR/ADMIN-TIL000_004",
  },
  {
    label: "Corporate-INFORMATION SYSTEMS-TIL000_005",
    value: "Corporate-INFORMATION SYSTEMS-TIL000_005",
  },
  { label: "Corporate-LEGAL-TIL000_006", value: "Corporate-LEGAL-TIL000_006" },
  {
    label: "Corporate-UK CORPORATE-TIL000_007",
    value: "Corporate-UK CORPORATE-TIL000_007",
  },
  {
    label: "Corporate-REGULATORY-TIL000_008",
    value: "Corporate-REGULATORY-TIL000_008",
  },
  { label: "Corporate-QA/QC-TIL000_010", value: "Corporate-QA/QC-TIL000_010" },
  { label: "Corporate-PV-TIL000_012", value: "Corporate-PV-TIL000_012" },
  {
    label: "Retail-ACCOUNTS & FINANCE-TIL001_001",
    value: "Retail-ACCOUNTS & FINANCE-TIL001_001",
  },
  {
    label: "Retail-BUSINESS DEVELOPMENT-TIL001_002",
    value: "Retail-BUSINESS DEVELOPMENT-TIL001_002",
  },
  { label: "Retail-HR/ADMIN-TIL001_004", value: "Retail-HR/ADMIN-TIL001_004" },
  {
    label: "Retail-INFORMATION SYSTEMS-TIL001_005",
    value: "Retail-INFORMATION SYSTEMS-TIL001_005",
  },
  { label: "Retail-LEGAL-TIL001_006", value: "Retail-LEGAL-TIL001_006" },
  { label: "Retail-QA/QC-TIL001_007", value: "Retail-QA/QC-TIL001_007" },
  {
    label: "Retail-REGULATORY-TIL001_008",
    value: "Retail-REGULATORY-TIL001_008",
  },
  {
    label: "Retail-SALES & MARKETING-TIL001_009",
    value: "Retail-SALES & MARKETING-TIL001_009",
  },
  { label: "Retail-SOURCING-TIL001_010", value: "Retail-SOURCING-TIL001_010" },
  {
    label: "Retail-WAREHOUSE-TIL001_011",
    value: "Retail-WAREHOUSE-TIL001_011",
  },
  { label: "Retail-PV-TIL001_012", value: "Retail-PV-TIL001_012" },
  {
    label: "Hospital-BUSINESS DEVELOPMENT-TIL002_002",
    value: "Hospital-BUSINESS DEVELOPMENT-TIL002_002",
  },
  {
    label: "Hospital-HR/ADMIN-TIL002_004",
    value: "Hospital-HR/ADMIN-TIL002_004",
  },
  { label: "Hospital-QA/QC-TIL002_007", value: "Hospital-QA/QC-TIL002_007" },
  {
    label: "Hospital-REGULATORY-TIL002_008",
    value: "Hospital-REGULATORY-TIL002_008",
  },
  {
    label: "Hospital-SALES & MARKETING-TIL002_009",
    value: "Hospital-SALES & MARKETING-TIL002_009",
  },
  {
    label: "Hospital-SOURCING-TIL002_010",
    value: "Hospital-SOURCING-TIL002_010",
  },
  {
    label: "Hospital-WAREHOUSE-TIL002_011",
    value: "Hospital-WAREHOUSE-TIL002_011",
  },
  { label: "Hospital-PV-TIL002_012", value: "Hospital-PV-TIL002_012" },
  {
    label: "Distribution-BUSINESS DEVELOPMENT-TIL003_002",
    value: "Distribution-BUSINESS DEVELOPMENT-TIL003_002",
  },
  {
    label: "Distribution-HR/ADMIN-TIL003_004",
    value: "Distribution-HR/ADMIN-TIL003_004",
  },
  {
    label: "Distribution-QA/QC-TIL003_007",
    value: "Distribution-QA/QC-TIL003_007",
  },
  {
    label: "Distribution-REGULATORY-TIL003_008",
    value: "Distribution-REGULATORY-TIL003_008",
  },
  {
    label: "Distribution-SALES & MARKETING-TIL003_009",
    value: "Distribution-SALES & MARKETING-TIL003_009",
  },
  {
    label: "Distribution-SOURCING-TIL003_010",
    value: "Distribution-SOURCING-TIL003_010",
  },
  {
    label: "Distribution-WAREHOUSE-TIL003_011",
    value: "Distribution-WAREHOUSE-TIL003_011",
  },
  { label: "Distribution-PV-TIL003_012", value: "Distribution-PV-TIL003_012" },
  {
    label: "UK Corporate-ACCOUNTS & FINANCE-TIL004_001",
    value: "UK Corporate-ACCOUNTS & FINANCE-TIL004_001",
  },
  {
    label: "UK Corporate-HR/ADMIN-TIL004_004",
    value: "UK Corporate-HR/ADMIN-TIL004_004",
  },
  {
    label: "UK Corporate-INFORMATION SYSTEMS-TIL004_005",
    value: "UK Corporate-INFORMATION SYSTEMS-TIL004_005",
  },
  {
    label: "UK Corporate-LEGAL-TIL004_006",
    value: "UK Corporate-LEGAL-TIL004_006",
  },
  {
    label: "UK Corporate-QA/QC-TIL004_007",
    value: "UK Corporate-QA/QC-TIL004_007",
  },
  {
    label: "UK Corporate-REGULATORY-TIL004_008",
    value: "UK Corporate-REGULATORY-TIL004_008",
  },
  {
    label: "UK Corporate-SOURCING-TIL004_010",
    value: "UK Corporate-SOURCING-TIL004_010",
  },
  {
    label: "UK Corporate-WAREHOUSE-TIL004_011",
    value: "UK Corporate-WAREHOUSE-TIL004_011",
  },
  { label: "UK Corporate-PV-TIL004_012", value: "UK Corporate-PV-TIL004_012" },
  { label: "Manx-QA/QC-TIL008_007", value: "Manx-QA/QC-TIL008_007" },
  { label: "Manx-REGULATORY-TIL008_008", value: "Manx-REGULATORY-TIL008_008" },
  {
    label: "Manx-SALES & MARKETING-TIL008_009",
    value: "Manx-SALES & MARKETING-TIL008_009",
  },
  { label: "Manx-SOURCING-TIL008_010", value: "Manx-SOURCING-TIL008_010" },
  { label: "Manx-WAREHOUSE-TIL008_011", value: "Manx-WAREHOUSE-TIL008_011" },
  { label: "Manx-PV-TIL008_012", value: "Manx-PV-TIL008_012" },
];

export const creditIndicator = addNA([
  { label: "H Credit", value: "h" },
  { label: "S Debit", value: "s" }
])
